import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type ActionChoice = {
  __typename?: 'ActionChoice';
  choice: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelectOptions?: Maybe<Array<Maybe<MultiSelectChoice>>>;
};

export type ActionInput = {
  choice: Scalars['String']['input'];
  multiSelectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  taskID: Scalars['String']['input'];
};

export type ActionPayload = {
  __typename?: 'ActionPayload';
  actionType: ActionType;
  choices: Array<Maybe<ActionChoice>>;
  taskID: Scalars['String']['output'];
};

export enum ActionType {
  CalendarIntegration = 'CALENDAR_INTEGRATION',
  ConfirmCalendarPlan = 'CONFIRM_CALENDAR_PLAN',
  ConfirmConflict = 'CONFIRM_CONFLICT',
  MathConfirmation = 'MATH_CONFIRMATION',
  PickOptimalTimes = 'PICK_OPTIMAL_TIMES'
}

export type ActionableInvite = {
  __typename?: 'ActionableInvite';
  invite: PlaydateInvite;
  suggestion?: Maybe<PlaydateInviteSuggestion>;
};

export type AnalysisStatus = {
  __typename?: 'AnalysisStatus';
  completedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  status: TaskStatusType;
  taskID: Scalars['String']['output'];
};

export enum AttentionLevelType {
  ActionRequired = 'ACTION_REQUIRED',
  FamilyEvent = 'FAMILY_EVENT',
  Informational = 'INFORMATIONAL',
  MayNeedAction = 'MAY_NEED_ACTION',
  Reminder = 'REMINDER'
}

export type CalendarAddStatus = {
  __typename?: 'CalendarAddStatus';
  success: Scalars['Boolean']['output'];
};

export type CalendarConnection = {
  __typename?: 'CalendarConnection';
  calendars?: Maybe<Array<CalendarEntry>>;
  expired: Scalars['Boolean']['output'];
  identifier: Scalars['String']['output'];
  label: Scalars['String']['output'];
  source: ExternalSource;
};

export type CalendarConnectionInput = {
  identifier: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  source: ExternalSource;
};

export type CalendarEntry = {
  __typename?: 'CalendarEntry';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CalendarEntryInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CalendarMetadata = {
  __typename?: 'CalendarMetadata';
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: ExternalSource;
  type: Scalars['String']['output'];
};

export enum CalendarReminderType {
  Birthday = 'BIRTHDAY',
  Caretaker = 'CARETAKER',
  ChildActivity = 'CHILD_ACTIVITY',
  FamilyEvent = 'FAMILY_EVENT',
  General = 'GENERAL',
  None = 'NONE',
  Playdate = 'PLAYDATE',
  SchoolClosure = 'SCHOOL_CLOSURE'
}

export type CalendarRemoveStatus = {
  __typename?: 'CalendarRemoveStatus';
  success: Scalars['Boolean']['output'];
};

export type CalendarSyncStatus = {
  __typename?: 'CalendarSyncStatus';
  calendarID: Scalars['String']['output'];
  lastCompletedAt: Scalars['String']['output'];
  source: SyncSourceType;
  status: TaskStatusType;
  syncRange?: Maybe<SyncRange>;
};

export type CaretakerDetails = {
  __typename?: 'CaretakerDetails';
  contactInfo: Scalars['String']['output'];
  isInactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
  userSummary?: Maybe<UserSummary>;
};

export type CaretakerDetailsInput = {
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type CaretakerInput = {
  contactInfo: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CaretakerRemoveStatus = {
  __typename?: 'CaretakerRemoveStatus';
  success: Scalars['Boolean']['output'];
};

export type CaretakerRequest = {
  __typename?: 'CaretakerRequest';
  accessToken?: Maybe<Scalars['String']['output']>;
  caretakers?: Maybe<Array<Maybe<CaretakerDetails>>>;
  confirmed: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  requestContext?: Maybe<RequestContext>;
  requestID: Scalars['ID']['output'];
  requester: UserSummary;
  responses?: Maybe<Array<Maybe<CaretakerResponse>>>;
  timeRange: TimeRange;
  updatedAt: Scalars['String']['output'];
};


export type CaretakerRequestResponsesArgs = {
  responseType?: InputMaybe<CaretakerResponseType>;
};

export type CaretakerResponse = {
  __typename?: 'CaretakerResponse';
  createdAt: Scalars['String']['output'];
  requestID: Scalars['ID']['output'];
  requester: UserSummary;
  responder?: Maybe<CaretakerDetails>;
  responseID: Scalars['ID']['output'];
  responseType?: Maybe<CaretakerResponseType>;
  updatedAt: Scalars['String']['output'];
};

export type CaretakerResponseDetailsInput = {
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum CaretakerResponseType {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export enum CaretakerType {
  Other = 'OTHER',
  Self = 'SELF',
  Spouse = 'SPOUSE'
}

export type Child = {
  __typename?: 'Child';
  birthday: Scalars['String']['output'];
  childID: Scalars['ID']['output'];
  currentSchool?: Maybe<SchoolEntry>;
  gender: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schoolHistory?: Maybe<Array<SchoolEntry>>;
};

export type ChildInput = {
  birthday: Scalars['String']['input'];
  childID?: InputMaybe<Scalars['ID']['input']>;
  currentSchool?: InputMaybe<SchoolEntryInput>;
  gender: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schoolHistory?: InputMaybe<Array<SchoolEntryInput>>;
};

export type ChildSummary = {
  __typename?: 'ChildSummary';
  gender?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ChildcareNotificationMetadata = {
  __typename?: 'ChildcareNotificationMetadata';
  requestID: Scalars['ID']['output'];
  responseID?: Maybe<Scalars['ID']['output']>;
};

export type Connection = {
  __typename?: 'Connection';
  connectionID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  participant: ParticipantSummary;
  status: ConnectionStatus;
  updatedAt: Scalars['String']['output'];
};

export type ConnectionConnection = {
  __typename?: 'ConnectionConnection';
  edges: Array<ConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectionEdge = {
  __typename?: 'ConnectionEdge';
  cursor: Scalars['String']['output'];
  node: Connection;
};

export type ConnectionFilterInput = {
  type: ConnectionFilterType;
};

export enum ConnectionFilterType {
  All = 'ALL',
  OldestChild = 'OLDEST_CHILD',
  School = 'SCHOOL'
}

export type ConnectionHubPage = {
  __typename?: 'ConnectionHubPage';
  connectionsMeta: Array<ConnectionsMeta>;
  renderType: ConnectionRenderType;
  sections: Array<ConnectionSection>;
};

export type ConnectionHubPageFilterInput = {
  highLevelFilter?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConnectionRenderType {
  Family = 'FAMILY',
  Parent = 'PARENT'
}

export type ConnectionSection = {
  __typename?: 'ConnectionSection';
  connections: Array<Connection>;
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  networkType?: Maybe<NetworkType>;
  priorityType?: Maybe<PriorityType>;
  title: Scalars['String']['output'];
  urgencyType?: Maybe<UrgencyType>;
};

export enum ConnectionStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export type ConnectionsMeta = {
  __typename?: 'ConnectionsMeta';
  filter: ConnectionFilterType;
  initialCursor?: Maybe<Scalars['String']['output']>;
  renderType: ConnectionRenderType;
};

export type ContextHeader = {
  __typename?: 'ContextHeader';
  attentionLevel?: Maybe<AttentionLevelType>;
  description?: Maybe<Scalars['String']['output']>;
  mainTitle?: Maybe<Scalars['String']['output']>;
  topTitle?: Maybe<Scalars['String']['output']>;
};

export type ContextHeaderInput = {
  attentionLevel?: InputMaybe<AttentionLevelType>;
  description?: InputMaybe<Scalars['String']['input']>;
  mainTitle?: InputMaybe<Scalars['String']['input']>;
  topTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCaretakeResponseInput = {
  caretakerDetails: CaretakerResponseDetailsInput;
  requestID: Scalars['ID']['input'];
  responseType: CaretakerResponseType;
};

export type CreateCaretakerRequestInput = {
  caretakers: Array<CaretakerDetailsInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  requestContext?: InputMaybe<RequestContextInput>;
  timeRange: TimeRangeInput;
};

export type CreatePlaydateInviteInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  externalGuests?: InputMaybe<Array<ExternalGuestInput>>;
  guestIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  guestType?: InputMaybe<PlaydateGuestType>;
  location?: InputMaybe<Scalars['String']['input']>;
  optionType: ScheduleOptionType;
  organizerID: Scalars['String']['input'];
  playdateType: PlaydateType;
  rsvpDeadline?: InputMaybe<Scalars['String']['input']>;
  scheduleOptions: Array<ScheduleOptionInput>;
  title: Scalars['String']['input'];
};

export type CreatePlaydateInviteResponseInput = {
  externalGuest?: InputMaybe<ExternalGuestInput>;
  inviteID: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  responseType: ResponseType;
  selectedScheduleOptions?: InputMaybe<Array<ScheduleOptionInput>>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DayPart {
  EarlyAfternoon = 'EARLY_AFTERNOON',
  Evening = 'EVENING',
  LateAfternoon = 'LATE_AFTERNOON',
  Morning = 'MORNING'
}

export type Digest = {
  __typename?: 'Digest';
  generatedAt: Scalars['String']['output'];
  sections: Array<DigestSection>;
  userID: Scalars['ID']['output'];
};

export type DigestContent = ActionableInvite | Event | GroupedEvent;

export type DigestItem = {
  __typename?: 'DigestItem';
  additionalContext?: Maybe<Scalars['JSON']['output']>;
  attentionLevel: AttentionLevelType;
  content: DigestContent;
  itemHeader?: Maybe<ItemHeader>;
  itemType: Scalars['String']['output'];
  mainReminderType?: Maybe<CalendarReminderType>;
};

export type DigestSection = {
  __typename?: 'DigestSection';
  items: Array<DigestItem>;
  sectionDescription?: Maybe<Scalars['String']['output']>;
  sectionTitle: Scalars['String']['output'];
  sectionType: DigestSectionType;
};

export enum DigestSectionType {
  Events = 'EVENTS',
  Priority = 'PRIORITY'
}

export type Event = {
  __typename?: 'Event';
  caretakerDetails?: Maybe<CaretakerDetails>;
  caretakerRequests?: Maybe<Array<CaretakerRequest>>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  eventID: Scalars['ID']['output'];
  organizerID?: Maybe<Scalars['ID']['output']>;
  owner: EventOwner;
  reminderType?: Maybe<CalendarReminderType>;
  startDate: Scalars['String']['output'];
  subType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type EventDetails = {
  __typename?: 'EventDetails';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  eventID?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EventDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventID: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EventOwner = {
  __typename?: 'EventOwner';
  userID: Scalars['ID']['output'];
  userSummary?: Maybe<UserSummary>;
  viewerRelationship: ViewerRelationshipType;
};

export type ExternalGuest = {
  __typename?: 'ExternalGuest';
  contactInfo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExternalGuestInput = {
  contactInfo: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum ExternalSource {
  Apple = 'Apple',
  Google = 'Google'
}

export type Family = {
  __typename?: 'Family';
  children: Array<Child>;
  createdAt: Scalars['String']['output'];
  familyID: Scalars['ID']['output'];
  members: Array<FamilyMember>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type FamilyMember = {
  __typename?: 'FamilyMember';
  personID: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

export type FamilySummary = {
  __typename?: 'FamilySummary';
  children?: Maybe<Array<ChildSummary>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parents: Array<UserSummary>;
};

export type FeatureIntroCompleteResult = {
  __typename?: 'FeatureIntroCompleteResult';
  onboardingStatus: OnboardingStatus;
};

export type FeatureIntroStatus = {
  __typename?: 'FeatureIntroStatus';
  digest?: Maybe<Scalars['Boolean']['output']>;
  inviteCreate?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeatureIntroType {
  Digest = 'DIGEST',
  InviteCreate = 'INVITE_CREATE'
}

export type GenerateSuggestionInput = {
  context?: InputMaybe<SuggestionContextInput>;
  parameters?: InputMaybe<SuggestionParametersInput>;
  requestedFeature: RequestedFeature;
};

export type GenericReminderMetadata = {
  __typename?: 'GenericReminderMetadata';
  eventDate?: Maybe<Scalars['Time']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reminderID?: Maybe<Scalars['ID']['output']>;
};

export type GroupEvent = {
  __typename?: 'GroupEvent';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  eventID: Scalars['ID']['output'];
  groupID: Scalars['ID']['output'];
  inheritedFromGroupID?: Maybe<Scalars['ID']['output']>;
  startDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type GroupEventResponse = {
  __typename?: 'GroupEventResponse';
  action: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  eventID: Scalars['ID']['output'];
  groupID: Scalars['ID']['output'];
  responseID: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
};

export type GroupedEvent = {
  __typename?: 'GroupedEvent';
  date: Scalars['String']['output'];
  mainEvents?: Maybe<Array<Event>>;
  mainReminderType?: Maybe<CalendarReminderType>;
  otherEvents?: Maybe<Array<Event>>;
  playdateInvites?: Maybe<Array<PlaydateInvite>>;
  relatedEvents?: Maybe<Array<Event>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export enum GuestUpdateType {
  Finalized = 'FINALIZED',
  InviteCancelled = 'INVITE_CANCELLED',
  InviteCreated = 'INVITE_CREATED',
  InviteModified = 'INVITE_MODIFIED',
  None = 'NONE',
  ResponseRecorded = 'RESPONSE_RECORDED',
  ResponseRejected = 'RESPONSE_REJECTED',
  ResponseRequested = 'RESPONSE_REQUESTED'
}

export enum InboxItemType {
  InboundPlaydate = 'INBOUND_PLAYDATE',
  OutboundPlaydate = 'OUTBOUND_PLAYDATE'
}

export type Interaction = {
  __typename?: 'Interaction';
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  messages: Array<Message>;
  title: Scalars['String']['output'];
};

export enum InviteStatus {
  Abandoned = 'ABANDONED',
  Confirmed = 'CONFIRMED',
  InPlanning = 'IN_PLANNING'
}

export type ItemHeader = {
  __typename?: 'ItemHeader';
  description?: Maybe<Scalars['String']['output']>;
  mainTitle?: Maybe<Scalars['String']['output']>;
  topTitle?: Maybe<Scalars['String']['output']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type Message = {
  __typename?: 'Message';
  actionPayload?: Maybe<ActionPayload>;
  content: Scalars['String']['output'];
  createTimestamp: Scalars['String']['output'];
  messageType: MessageType;
  role: Scalars['String']['output'];
  toolPayload?: Maybe<ToolPayload>;
};

export enum MessageType {
  Action = 'ACTION',
  Text = 'TEXT',
  Tool = 'TOOL'
}

export type MultiSelectChoice = {
  __typename?: 'MultiSelectChoice';
  choice: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCaretaker: CaretakerDetails;
  addExternalCalendars?: Maybe<CalendarAddStatus>;
  addUserToFamily: User;
  completeDeviceSync?: Maybe<SyncStatus>;
  createCaretakerRequest: CaretakerRequest;
  createCaretakerResponse: CaretakerResponse;
  createInteraction?: Maybe<Interaction>;
  createOrUpdatePushToken: UpdateTokenResponse;
  createPlaydateInvite: PlaydateInvite;
  createPlaydateInviteResponse: PlaydateInviteResponse;
  deletePlaydateInvite: PlaydateInvite;
  generateCaretakerAssignmentEvent: Event;
  handleNewUserMessage?: Maybe<ResponsePayload>;
  handleUserAction?: Maybe<ResponsePayload>;
  logout?: Maybe<LogoutResponse>;
  markFeatureIntroComplete: FeatureIntroCompleteResult;
  markNotificationsSeen: Scalars['Boolean']['output'];
  markOnboardingComplete: OnboardingStatus;
  removeCalendarConnection?: Maybe<CalendarRemoveStatus>;
  removeCaretaker?: Maybe<CaretakerRemoveStatus>;
  saveUserProfile: User;
  saveUserProfilePicture: User;
  saveUserSpouseEmail: User;
  startDeviceSync?: Maybe<SyncStatus>;
  updateCaretakerResponse: CaretakerResponse;
  updateInboxSeenStatus: SeenStatusUpdateResult;
  updatePlaydateInvite: PlaydateInvite;
  updatePlaydateInviteResponse: PlaydateInviteResponse;
  upsertChildren: Family;
};


export type MutationAddCaretakerArgs = {
  input: CaretakerInput;
};


export type MutationAddExternalCalendarsArgs = {
  entries: Array<CalendarEntryInput>;
  input: CalendarConnectionInput;
};


export type MutationAddUserToFamilyArgs = {
  familyID: Scalars['ID']['input'];
};


export type MutationCompleteDeviceSyncArgs = {
  identifier: Scalars['String']['input'];
  status: TaskStatusType;
  syncType: SyncType;
};


export type MutationCreateCaretakerRequestArgs = {
  input: CreateCaretakerRequestInput;
};


export type MutationCreateCaretakerResponseArgs = {
  input: CreateCaretakeResponseInput;
};


export type MutationCreateInteractionArgs = {
  messages?: InputMaybe<Array<InputMaybe<NewMessageInput>>>;
  withUserID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrUpdatePushTokenArgs = {
  deviceId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreatePlaydateInviteArgs = {
  input: CreatePlaydateInviteInput;
};


export type MutationCreatePlaydateInviteResponseArgs = {
  input: CreatePlaydateInviteResponseInput;
};


export type MutationDeletePlaydateInviteArgs = {
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  inviteID: Scalars['ID']['input'];
};


export type MutationGenerateCaretakerAssignmentEventArgs = {
  caretakerType: CaretakerType;
  eventID: Scalars['ID']['input'];
};


export type MutationHandleNewUserMessageArgs = {
  interactionID: Scalars['ID']['input'];
  message: NewMessageInput;
};


export type MutationHandleUserActionArgs = {
  actionInput?: InputMaybe<ActionInput>;
  interactionID: Scalars['ID']['input'];
};


export type MutationMarkFeatureIntroCompleteArgs = {
  input: FeatureIntroType;
};


export type MutationMarkNotificationsSeenArgs = {
  notificationIDs: Array<Scalars['ID']['input']>;
};


export type MutationRemoveCalendarConnectionArgs = {
  connection: CalendarConnectionInput;
};


export type MutationRemoveCaretakerArgs = {
  caretakerID: Scalars['ID']['input'];
};


export type MutationSaveUserProfileArgs = {
  input: UserProfileInput;
};


export type MutationSaveUserProfilePictureArgs = {
  input: Scalars['String']['input'];
};


export type MutationSaveUserSpouseEmailArgs = {
  input: Scalars['String']['input'];
};


export type MutationStartDeviceSyncArgs = {
  identifier: Scalars['String']['input'];
  syncType: SyncType;
};


export type MutationUpdateCaretakerResponseArgs = {
  input: UpdateCaretakerResponseInput;
};


export type MutationUpdateInboxSeenStatusArgs = {
  itemType: InboxItemType;
  updateID: Scalars['ID']['input'];
};


export type MutationUpdatePlaydateInviteArgs = {
  input: UpdatePlaydateInviteInput;
  inviteID: Scalars['ID']['input'];
};


export type MutationUpdatePlaydateInviteResponseArgs = {
  input: UpdatePlaydateInviteResponseInput;
  responseID: Scalars['ID']['input'];
};


export type MutationUpsertChildrenArgs = {
  children: Array<ChildInput>;
};

export enum NetworkType {
  Direct = 'DIRECT',
  Neighborhood = 'NEIGHBORHOOD',
  School = 'SCHOOL'
}

export type NewMessageInput = {
  content: Scalars['String']['input'];
  messageType?: InputMaybe<MessageType>;
  toolPayload?: InputMaybe<ToolPayloadInput>;
};

export type Notification = {
  __typename?: 'Notification';
  content: NotificationContent;
  createdAt: Scalars['Time']['output'];
  icon: NotificationIconType;
  id: Scalars['ID']['output'];
  mainCTA?: Maybe<NotificationCta>;
  metadata?: Maybe<NotificationMetadata>;
  seenState: SeenState;
  type: NotificationType;
};

export enum NotificationActionType {
  OpenExternalUrl = 'OPEN_EXTERNAL_URL',
  View = 'VIEW'
}

export type NotificationCta = {
  __typename?: 'NotificationCTA';
  actionType: NotificationActionType;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type NotificationContent = {
  __typename?: 'NotificationContent';
  formattedText?: Maybe<Scalars['String']['output']>;
  rawText: Scalars['String']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export enum NotificationIconType {
  ActionRequired = 'ACTION_REQUIRED',
  Info = 'INFO',
  Reminder = 'REMINDER'
}

export type NotificationMetadata = ChildcareNotificationMetadata | GenericReminderMetadata | PlaydateNotificationMetadata;

export enum NotificationType {
  ChildcareRequest = 'CHILDCARE_REQUEST',
  GenericReminder = 'GENERIC_REMINDER',
  PlaydateInvite = 'PLAYDATE_INVITE'
}

export type OnboardingStatus = {
  __typename?: 'OnboardingStatus';
  completed: Scalars['Boolean']['output'];
  featureIntroStatus?: Maybe<FeatureIntroStatus>;
};

export enum OrganizerUpdateType {
  EnoughResponseReceived = 'ENOUGH_RESPONSE_RECEIVED',
  Finalized = 'FINALIZED',
  GuestRejected = 'GUEST_REJECTED',
  InviteCancelled = 'INVITE_CANCELLED',
  InviteCreated = 'INVITE_CREATED',
  InviteModified = 'INVITE_MODIFIED',
  None = 'NONE',
  ResponseModified = 'RESPONSE_MODIFIED',
  ResponseReceived = 'RESPONSE_RECEIVED'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type ParticipantSummary = FamilySummary | UserSummary;

export enum PlaydateGuestType {
  Family = 'FAMILY',
  Parent = 'PARENT'
}

export type PlaydateInvite = {
  __typename?: 'PlaydateInvite';
  accessToken?: Maybe<Scalars['String']['output']>;
  cancellationMessage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  details?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  externalGuests?: Maybe<Array<ExternalGuest>>;
  finalScheduleOption?: Maybe<Array<ScheduleOption>>;
  guestType: PlaydateGuestType;
  guestUpdate?: Maybe<PlaydateInviteGuestUpdate>;
  guests?: Maybe<Array<ParticipantSummary>>;
  inviteID: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  organizer: ParticipantSummary;
  organizerUpdate?: Maybe<PlaydateInviteOrganizerUpdate>;
  playdateType: PlaydateType;
  recurrenceStartDate?: Maybe<Scalars['Time']['output']>;
  responses?: Maybe<Array<PlaydateInviteResponse>>;
  rsvpDeadline?: Maybe<Scalars['Time']['output']>;
  scheduleOptionType: ScheduleOptionType;
  scheduleOptions: Array<ScheduleOption>;
  status: InviteStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  viewerResponse?: Maybe<PlaydateInviteResponse>;
};

export type PlaydateInviteConnection = {
  __typename?: 'PlaydateInviteConnection';
  edges: Array<PlaydateInviteEdge>;
  pageInfo: PageInfo;
};

export type PlaydateInviteContextInput = {
  eventID?: InputMaybe<Scalars['ID']['input']>;
  inviteID?: InputMaybe<Scalars['ID']['input']>;
  organizerID?: InputMaybe<Scalars['ID']['input']>;
};

export type PlaydateInviteEdge = {
  __typename?: 'PlaydateInviteEdge';
  cursor: Scalars['String']['output'];
  node: PlaydateInvite;
};

export type PlaydateInviteGuestUpdate = {
  __typename?: 'PlaydateInviteGuestUpdate';
  createdAt: Scalars['Time']['output'];
  guestID: Scalars['String']['output'];
  inviteID?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  responseID?: Maybe<Scalars['ID']['output']>;
  seenState: SeenStatus;
  updateID: Scalars['ID']['output'];
  updateType: GuestUpdateType;
  updatedAt: Scalars['Time']['output'];
};

export type PlaydateInviteOrganizerUpdate = {
  __typename?: 'PlaydateInviteOrganizerUpdate';
  createdAt: Scalars['Time']['output'];
  inviteID?: Maybe<Scalars['ID']['output']>;
  lastResponder?: Maybe<Responder>;
  message?: Maybe<Scalars['String']['output']>;
  organizerID: Scalars['String']['output'];
  seenState: SeenStatus;
  updateID: Scalars['ID']['output'];
  updateType: OrganizerUpdateType;
  updatedAt: Scalars['Time']['output'];
};

export type PlaydateInviteResponse = {
  __typename?: 'PlaydateInviteResponse';
  createdAt: Scalars['Time']['output'];
  externalGuest?: Maybe<ExternalGuest>;
  guest: ParticipantSummary;
  invite?: Maybe<PlaydateInvite>;
  inviteID: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  responseID: Scalars['ID']['output'];
  responseType: ResponseType;
  selectedScheduleOptions?: Maybe<Array<ScheduleOption>>;
  updatedAt: Scalars['Time']['output'];
};

export type PlaydateInviteResponseResult = {
  __typename?: 'PlaydateInviteResponseResult';
  invite: PlaydateInvite;
};

export type PlaydateInviteSuggestion = {
  __typename?: 'PlaydateInviteSuggestion';
  id: Scalars['ID']['output'];
  scheduleSuggestion?: Maybe<ScheduleSuggestion>;
  textualSuggestion?: Maybe<TextualSuggestion>;
};

export type PlaydateInviteSuggestionInput = {
  connectionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
};

export type PlaydateNotificationMetadata = {
  __typename?: 'PlaydateNotificationMetadata';
  inviteID: Scalars['ID']['output'];
  responseID?: Maybe<Scalars['ID']['output']>;
};

export enum PlaydateType {
  Open = 'OPEN',
  Private = 'PRIVATE'
}

export type Post = {
  __typename?: 'Post';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['ID']['output'];
  postID: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum PriorityType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Query = {
  __typename?: 'Query';
  checkSession: SessionStatus;
  fetchConnectionHubPages: Array<ConnectionHubPage>;
  fetchConnectionSections: Array<ConnectionSection>;
  fetchConnectionsByFilter: ConnectionConnection;
  generateDigest: Digest;
  generateSuggestions: SuggestionResult;
  getAnalysisStatus?: Maybe<AnalysisStatus>;
  getCalendarConnections: Array<CalendarConnection>;
  getCaretakerDetails: Array<CaretakerDetails>;
  getCaretakerRequest?: Maybe<CaretakerRequest>;
  getConnections: ConnectionConnection;
  getDeviceRequiredSync?: Maybe<Array<Maybe<CalendarSyncStatus>>>;
  getInteraction?: Maybe<Interaction>;
  getPlaydateInvite?: Maybe<PlaydateInvite>;
  getPlaydateInviteResponse?: Maybe<PlaydateInviteResponse>;
  getSyncStatus?: Maybe<SyncStatus>;
  getUser?: Maybe<User>;
  getUserExternalCalendarList: Array<Maybe<CalendarMetadata>>;
  getUserInteractions: Array<Interaction>;
  getUserOnboardingStatus: OnboardingStatus;
  getViewerPlaydateInviteResponse?: Maybe<PlaydateInviteResponse>;
  listInboxInvites: PlaydateInviteConnection;
  listPlaydateInvites: PlaydateInviteConnection;
  notification?: Maybe<Notification>;
  notifications: NotificationConnection;
};


export type QueryFetchConnectionHubPagesArgs = {
  filters?: InputMaybe<ConnectionHubPageFilterInput>;
};


export type QueryFetchConnectionsByFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: ConnectionFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  renderType: ConnectionRenderType;
};


export type QueryGenerateDigestArgs = {
  withUserID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateSuggestionsArgs = {
  input: GenerateSuggestionInput;
};


export type QueryGetAnalysisStatusArgs = {
  taskID: Scalars['String']['input'];
};


export type QueryGetCaretakerDetailsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  withUserID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCaretakerRequestArgs = {
  requestID?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetConnectionsArgs = {
  renderType: ConnectionRenderType;
};


export type QueryGetDeviceRequiredSyncArgs = {
  identifier: Scalars['String']['input'];
  taskEnvironment: TaskEnvironmentType;
};


export type QueryGetInteractionArgs = {
  interactionID: Scalars['ID']['input'];
  withUserID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlaydateInviteArgs = {
  inviteID?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlaydateInviteResponseArgs = {
  responseID: Scalars['ID']['input'];
};


export type QueryGetSyncStatusArgs = {
  syncType: SyncType;
};


export type QueryGetUserExternalCalendarListArgs = {
  input: CalendarConnectionInput;
};


export type QueryGetViewerPlaydateInviteResponseArgs = {
  inviteID: Scalars['ID']['input'];
};


export type QueryListInboxInvitesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  guestID: Scalars['String']['input'];
  hasOrganizerID?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  seenState?: InputMaybe<SeenStatus>;
  since?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryListPlaydateInvitesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  hasGuestID?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  organizerID: Scalars['ID']['input'];
  seenState?: InputMaybe<SeenStatus>;
  since?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  seenState?: InputMaybe<SeenState>;
  since?: InputMaybe<Scalars['Time']['input']>;
};

export type RequestContext = {
  __typename?: 'RequestContext';
  contextHeader?: Maybe<ContextHeader>;
  eventDetails?: Maybe<EventDetails>;
};

export type RequestContextInput = {
  contextHeader?: InputMaybe<ContextHeaderInput>;
  eventDetails?: InputMaybe<EventDetailsInput>;
};

export enum RequestedFeature {
  CreatePlaydate = 'CREATE_PLAYDATE',
  EditPlaydate = 'EDIT_PLAYDATE',
  RespondPlaydate = 'RESPOND_PLAYDATE'
}

export type Responder = {
  __typename?: 'Responder';
  externalGuest?: Maybe<ExternalGuest>;
  responder?: Maybe<ParticipantSummary>;
};

export type ResponsePayload = {
  __typename?: 'ResponsePayload';
  archive: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  interactionID: Scalars['String']['output'];
  message: Message;
};

export enum ResponseType {
  Accept = 'ACCEPT',
  Maybe = 'MAYBE',
  NoResponse = 'NO_RESPONSE',
  Reject = 'REJECT'
}

export type ScheduleOption = {
  __typename?: 'ScheduleOption';
  date?: Maybe<Scalars['Time']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  dayPart?: Maybe<DayPart>;
  endTime?: Maybe<Scalars['Time']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type ScheduleOptionInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  dayPart?: InputMaybe<DayPart>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export enum ScheduleOptionType {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export type ScheduleSuggestion = {
  __typename?: 'ScheduleSuggestion';
  reason?: Maybe<Scalars['String']['output']>;
  rsvpDeadline?: Maybe<Scalars['Time']['output']>;
  scheduleOptions: Array<ScheduleOption>;
};

export type SchoolEntry = {
  __typename?: 'SchoolEntry';
  className?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  schoolName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type SchoolEntryInput = {
  className?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolName: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum SeenState {
  Seen = 'SEEN',
  Unseen = 'UNSEEN'
}

export enum SeenStatus {
  New = 'NEW',
  Read = 'READ'
}

export type SeenStatusUpdateResult = {
  __typename?: 'SeenStatusUpdateResult';
  success: Scalars['Boolean']['output'];
};

export type SessionStatus = {
  __typename?: 'SessionStatus';
  authenticated: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type SuggestionContextInput = {
  playdateInviteContext?: InputMaybe<PlaydateInviteContextInput>;
};

export type SuggestionParametersInput = {
  playdateInviteInput?: InputMaybe<PlaydateInviteSuggestionInput>;
  playdateInviteResponseInput?: InputMaybe<CreatePlaydateInviteResponseInput>;
  updatePlaydateInviteInput?: InputMaybe<UpdatePlaydateInviteInput>;
  updatePlaydateInviteResponseInput?: InputMaybe<UpdatePlaydateInviteResponseInput>;
  userMessage?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestionResult = {
  __typename?: 'SuggestionResult';
  playdateInviteSuggestions?: Maybe<Array<PlaydateInviteSuggestion>>;
  suggestionType: RequestedFeature;
};

export type SyncRange = {
  __typename?: 'SyncRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export enum SyncSourceType {
  Device = 'DEVICE',
  Online = 'ONLINE'
}

export type SyncStatus = {
  __typename?: 'SyncStatus';
  completedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  source: SyncSourceType;
  status: TaskStatusType;
  syncRange?: Maybe<SyncRange>;
  type: SyncType;
};

export enum SyncType {
  Continuous = 'CONTINUOUS',
  Initial = 'INITIAL',
  Invalid = 'INVALID'
}

export enum TaskEnvironmentType {
  Background = 'BACKGROUND',
  Foreground = 'FOREGROUND'
}

export enum TaskStatusType {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  NeedsSync = 'NEEDS_SYNC',
  NotConnected = 'NOT_CONNECTED',
  NotScheduled = 'NOT_SCHEDULED'
}

export type TextualSuggestion = {
  __typename?: 'TextualSuggestion';
  details?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type TimeRangeInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type ToolPayload = {
  __typename?: 'ToolPayload';
  args: Scalars['JSON']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  status: ToolStatus;
  toolName: Scalars['String']['output'];
};

export type ToolPayloadInput = {
  args: Scalars['JSON']['input'];
  status: ToolStatus;
  toolName: Scalars['String']['input'];
};

export enum ToolStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type UpdateCaretakerResponseInput = {
  newResponseType: CaretakerResponseType;
  responseID: Scalars['ID']['input'];
};

export type UpdatePlaydateInviteInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  externalGuests?: InputMaybe<Array<ExternalGuestInput>>;
  finalScheduleOption?: InputMaybe<Array<ScheduleOptionInput>>;
  guestIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Scalars['String']['input']>;
  optionType?: InputMaybe<ScheduleOptionType>;
  playdateType?: InputMaybe<PlaydateType>;
  recurrenceStartDate?: InputMaybe<Scalars['String']['input']>;
  rsvpDeadline?: InputMaybe<Scalars['String']['input']>;
  scheduleOptions?: InputMaybe<Array<ScheduleOptionInput>>;
  status?: InputMaybe<InviteStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlaydateInviteResponseInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  responseType?: InputMaybe<ResponseType>;
  selectedScheduleOptions?: InputMaybe<Array<ScheduleOptionInput>>;
};

export type UpdateTokenResponse = {
  __typename?: 'UpdateTokenResponse';
  success: Scalars['Boolean']['output'];
};

export enum UrgencyType {
  High = 'HIGH',
  Low = 'LOW'
}

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  family?: Maybe<FamilySummary>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  matchedFamily?: Maybe<FamilySummary>;
  onboardingStatus?: Maybe<OnboardingStatus>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  spouse?: Maybe<UserSummary>;
  spouseEmail?: Maybe<Scalars['String']['output']>;
};

export type UserProfileInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UserSummary = {
  __typename?: 'UserSummary';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
};

export enum ViewerRelationshipType {
  Other = 'OTHER',
  Self = 'SELF',
  Spouse = 'SPOUSE'
}

export type CaretakerDetailsFragmentFragment = { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null };

export type CaretakerRequestFragmentFragment = { __typename?: 'CaretakerRequest', requestID: string, createdAt: string, updatedAt: string, message?: string | null, confirmed: boolean, accessToken?: string | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, caretakers?: Array<{ __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null> | null, requestContext?: { __typename?: 'RequestContext', contextHeader?: { __typename?: 'ContextHeader', topTitle?: string | null, mainTitle?: string | null, description?: string | null, attentionLevel?: AttentionLevelType | null } | null, eventDetails?: { __typename?: 'EventDetails', title: string, eventID?: string | null, location?: string | null, description?: string | null, startDate: string, endDate?: string | null } | null } | null, timeRange: { __typename?: 'TimeRange', startDate: string, endDate: string }, responses?: Array<{ __typename?: 'CaretakerResponse', responseID: string, requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } | null> | null };

export type CaretakerResponseFragmentFragment = { __typename?: 'CaretakerResponse', responseID: string, requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null };

export type ConnectionFragmentFragment = { __typename?: 'Connection', connectionID: string, status: ConnectionStatus, createdAt: string, updatedAt: string, participant: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } };

export type EventOwnerFragmentFragment = { __typename?: 'EventOwner', userID: string, viewerRelationship: ViewerRelationshipType, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null };

export type NotificationFragmentFragment = { __typename?: 'Notification', id: string, type: NotificationType, icon: NotificationIconType, seenState: SeenState, createdAt: any, content: { __typename?: 'NotificationContent', rawText: string, formattedText?: string | null }, mainCTA?: { __typename?: 'NotificationCTA', label?: string | null, actionType: NotificationActionType, url?: string | null } | null, metadata?: { __typename: 'ChildcareNotificationMetadata', requestID: string, responseID?: string | null } | { __typename: 'GenericReminderMetadata', reminderID?: string | null, eventDate?: any | null, message?: string | null } | { __typename: 'PlaydateNotificationMetadata', inviteID: string, responseID?: string | null } | null };

type ParticipantSummaryFragment_FamilySummary_Fragment = { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> };

type ParticipantSummaryFragment_UserSummary_Fragment = { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string };

export type ParticipantSummaryFragmentFragment = ParticipantSummaryFragment_FamilySummary_Fragment | ParticipantSummaryFragment_UserSummary_Fragment;

export type ScheduleOptionFragmentFragment = { __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null };

export type ExternalGuestFragmentFragment = { __typename?: 'ExternalGuest', name: string, contactInfo: string };

export type ScheduleSuggestionFragmentFragment = { __typename?: 'ScheduleSuggestion', reason?: string | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> };

export type TextualSuggestionFragmentFragment = { __typename?: 'TextualSuggestion', title?: string | null, details?: string | null, location?: string | null, reason?: string | null };

export type PlaydateInviteSuggestionFragmentFragment = { __typename?: 'PlaydateInviteSuggestion', id: string, scheduleSuggestion?: { __typename?: 'ScheduleSuggestion', reason?: string | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> } | null, textualSuggestion?: { __typename?: 'TextualSuggestion', title?: string | null, details?: string | null, location?: string | null, reason?: string | null } | null };

export type PlaydateInviteGuestUpdateFragmentFragment = { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any };

export type PlaydateInviteOrganizerUpdateFragmentFragment = { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null };

export type PlaydateInviteResponseShallowFragmentFragment = { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null };

export type PlaydateInviteShallowFragmentFragment = { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null };

export type PlaydateInviteResponseFragmentFragment = { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null };

export type PlaydateInviteFragmentFragment = { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null };

export type RequestContextFragmentFragment = { __typename?: 'RequestContext', contextHeader?: { __typename?: 'ContextHeader', topTitle?: string | null, mainTitle?: string | null, description?: string | null, attentionLevel?: AttentionLevelType | null } | null, eventDetails?: { __typename?: 'EventDetails', title: string, eventID?: string | null, location?: string | null, description?: string | null, startDate: string, endDate?: string | null } | null };

export type UserSummaryFragmentFragment = { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string };

export type FamilySummaryFragmentFragment = { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> };

export type OnboardingStatusFieldsFragment = { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null };

export type UserFieldsFragment = { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null };

export type UserWithMatchedFamilyFieldsFragment = { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null, matchedFamily?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null };

export type AddCaretakerMutationVariables = Exact<{
  input: CaretakerInput;
}>;


export type AddCaretakerMutation = { __typename?: 'Mutation', addCaretaker: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean } };

export type AddExternalCalendarsMutationVariables = Exact<{
  calendar: CalendarConnectionInput;
  entries: Array<CalendarEntryInput> | CalendarEntryInput;
}>;


export type AddExternalCalendarsMutation = { __typename?: 'Mutation', addExternalCalendars?: { __typename?: 'CalendarAddStatus', success: boolean } | null };

export type AddUserToFamilyMutationVariables = Exact<{
  familyID: Scalars['ID']['input'];
}>;


export type AddUserToFamilyMutation = { __typename?: 'Mutation', addUserToFamily: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null } };

export type CreateCaretakerRequestMutationVariables = Exact<{
  input: CreateCaretakerRequestInput;
}>;


export type CreateCaretakerRequestMutation = { __typename?: 'Mutation', createCaretakerRequest: { __typename?: 'CaretakerRequest', requestID: string, createdAt: string, updatedAt: string, message?: string | null, confirmed: boolean, accessToken?: string | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, caretakers?: Array<{ __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null> | null, requestContext?: { __typename?: 'RequestContext', contextHeader?: { __typename?: 'ContextHeader', topTitle?: string | null, mainTitle?: string | null, description?: string | null, attentionLevel?: AttentionLevelType | null } | null, eventDetails?: { __typename?: 'EventDetails', title: string, eventID?: string | null, location?: string | null, description?: string | null, startDate: string, endDate?: string | null } | null } | null, timeRange: { __typename?: 'TimeRange', startDate: string, endDate: string }, responses?: Array<{ __typename?: 'CaretakerResponse', responseID: string, requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } | null> | null } };

export type CreateCaretakerResponseMutationVariables = Exact<{
  input: CreateCaretakeResponseInput;
}>;


export type CreateCaretakerResponseMutation = { __typename?: 'Mutation', createCaretakerResponse: { __typename?: 'CaretakerResponse', requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } };

export type CreateInteractionMutationVariables = Exact<{
  messages?: InputMaybe<Array<InputMaybe<NewMessageInput>> | InputMaybe<NewMessageInput>>;
}>;


export type CreateInteractionMutation = { __typename?: 'Mutation', createInteraction?: { __typename?: 'Interaction', id: string, title: string, messages: Array<{ __typename?: 'Message', role: string, content: string, createTimestamp: string, actionPayload?: { __typename?: 'ActionPayload', taskID: string, actionType: ActionType, choices: Array<{ __typename?: 'ActionChoice', label: string, choice: string, multiSelectOptions?: Array<{ __typename?: 'MultiSelectChoice', label: string, choice: string } | null> | null } | null> } | null }> } | null };

export type CreateOrUpdatePushTokenMutationVariables = Exact<{
  deviceID: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type CreateOrUpdatePushTokenMutation = { __typename?: 'Mutation', createOrUpdatePushToken: { __typename?: 'UpdateTokenResponse', success: boolean } };

export type CreatePlaydateInviteMutationVariables = Exact<{
  input: CreatePlaydateInviteInput;
}>;


export type CreatePlaydateInviteMutation = { __typename?: 'Mutation', createPlaydateInvite: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } };

export type CreatePlaydateInviteResponseMutationVariables = Exact<{
  input: CreatePlaydateInviteResponseInput;
}>;


export type CreatePlaydateInviteResponseMutation = { __typename?: 'Mutation', createPlaydateInviteResponse: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } };

export type DeletePlaydateInviteMutationVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeletePlaydateInviteMutation = { __typename?: 'Mutation', deletePlaydateInvite: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } };

export type HandleNewUserMessageMutationVariables = Exact<{
  interactionID: Scalars['ID']['input'];
  message: NewMessageInput;
}>;


export type HandleNewUserMessageMutation = { __typename?: 'Mutation', handleNewUserMessage?: { __typename?: 'ResponsePayload', completed: boolean, archive: boolean, message: { __typename?: 'Message', role: string, content: string, createTimestamp: string, messageType: MessageType, actionPayload?: { __typename?: 'ActionPayload', taskID: string, actionType: ActionType, choices: Array<{ __typename?: 'ActionChoice', label: string, choice: string, multiSelectOptions?: Array<{ __typename?: 'MultiSelectChoice', label: string, choice: string } | null> | null } | null> } | null } } | null };

export type HandleUserActionMutationVariables = Exact<{
  interactionID: Scalars['ID']['input'];
  actionInput: ActionInput;
}>;


export type HandleUserActionMutation = { __typename?: 'Mutation', handleUserAction?: { __typename?: 'ResponsePayload', completed: boolean, archive: boolean, message: { __typename?: 'Message', role: string, content: string, createTimestamp: string, actionPayload?: { __typename?: 'ActionPayload', taskID: string, actionType: ActionType, choices: Array<{ __typename?: 'ActionChoice', label: string, choice: string, multiSelectOptions?: Array<{ __typename?: 'MultiSelectChoice', label: string, choice: string } | null> | null } | null> } | null } } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutResponse', success: boolean } | null };

export type MarkFeatureIntroCompleteMutationVariables = Exact<{
  input: FeatureIntroType;
}>;


export type MarkFeatureIntroCompleteMutation = { __typename?: 'Mutation', markFeatureIntroComplete: { __typename?: 'FeatureIntroCompleteResult', onboardingStatus: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } } };

export type MarkNotificationsSeenMutationVariables = Exact<{
  notificationIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkNotificationsSeenMutation = { __typename?: 'Mutation', markNotificationsSeen: boolean };

export type MarkOnboardingCompleteMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkOnboardingCompleteMutation = { __typename?: 'Mutation', markOnboardingComplete: { __typename?: 'OnboardingStatus', completed: boolean } };

export type RemoveCalendarConnectionMutationVariables = Exact<{
  calendar: CalendarConnectionInput;
}>;


export type RemoveCalendarConnectionMutation = { __typename?: 'Mutation', removeCalendarConnection?: { __typename?: 'CalendarRemoveStatus', success: boolean } | null };

export type SaveUserProfileMutationVariables = Exact<{
  input: UserProfileInput;
}>;


export type SaveUserProfileMutation = { __typename?: 'Mutation', saveUserProfile: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null } };

export type SaveUserProfilePictureMutationVariables = Exact<{
  profilePictureURLInput: Scalars['String']['input'];
}>;


export type SaveUserProfilePictureMutation = { __typename?: 'Mutation', saveUserProfilePicture: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null } };

export type SaveUserSpouseEmailMutationVariables = Exact<{
  spouseEmailInput: Scalars['String']['input'];
}>;


export type SaveUserSpouseEmailMutation = { __typename?: 'Mutation', saveUserSpouseEmail: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null, matchedFamily?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null } };

export type UpdateCaretakerResponseMutationVariables = Exact<{
  input: UpdateCaretakerResponseInput;
}>;


export type UpdateCaretakerResponseMutation = { __typename?: 'Mutation', updateCaretakerResponse: { __typename?: 'CaretakerResponse', requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } };

export type UpdateInboxSeenStatusMutationVariables = Exact<{
  itemType: InboxItemType;
  input: Scalars['ID']['input'];
}>;


export type UpdateInboxSeenStatusMutation = { __typename?: 'Mutation', updateInboxSeenStatus: { __typename?: 'SeenStatusUpdateResult', success: boolean } };

export type UpdatePlaydateInviteMutationVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  input: UpdatePlaydateInviteInput;
}>;


export type UpdatePlaydateInviteMutation = { __typename?: 'Mutation', updatePlaydateInvite: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } };

export type UpdatePlaydateInviteResponseMutationVariables = Exact<{
  responseID: Scalars['ID']['input'];
  input: UpdatePlaydateInviteResponseInput;
}>;


export type UpdatePlaydateInviteResponseMutation = { __typename?: 'Mutation', updatePlaydateInviteResponse: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } };

export type UpsertChildrenMutationVariables = Exact<{
  children: Array<ChildInput> | ChildInput;
}>;


export type UpsertChildrenMutation = { __typename?: 'Mutation', upsertChildren: { __typename?: 'Family', children: Array<{ __typename?: 'Child', childID: string, name: string, gender: string, birthday: string, currentSchool?: { __typename?: 'SchoolEntry', schoolName: string, className?: string | null } | null }> } };

export type GenerateDigestQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateDigestQuery = { __typename?: 'Query', generateDigest: { __typename?: 'Digest', userID: string, generatedAt: string, sections: Array<{ __typename?: 'DigestSection', sectionTitle: string, sectionDescription?: string | null, sectionType: DigestSectionType, items: Array<{ __typename?: 'DigestItem', itemType: string, additionalContext?: any | null, attentionLevel: AttentionLevelType, mainReminderType?: CalendarReminderType | null, itemHeader?: { __typename?: 'ItemHeader', topTitle?: string | null, mainTitle?: string | null, description?: string | null } | null, content: { __typename: 'ActionableInvite', invite: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null }, suggestion?: { __typename?: 'PlaydateInviteSuggestion', id: string, scheduleSuggestion?: { __typename?: 'ScheduleSuggestion', reason?: string | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> } | null, textualSuggestion?: { __typename?: 'TextualSuggestion', title?: string | null, details?: string | null, location?: string | null, reason?: string | null } | null } | null } | { __typename: 'Event', eventID: string, title: string, startDate: string, endDate?: string | null, description?: string | null, owner: { __typename?: 'EventOwner', userID: string, viewerRelationship: ViewerRelationshipType, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } } | { __typename: 'GroupedEvent', date: string, mainReminderType?: CalendarReminderType | null, mainEvents?: Array<{ __typename?: 'Event', eventID: string, title: string, reminderType?: CalendarReminderType | null, startDate: string, endDate?: string | null, owner: { __typename?: 'EventOwner', userID: string, viewerRelationship: ViewerRelationshipType, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null }, caretakerRequests?: Array<{ __typename?: 'CaretakerRequest', requestID: string, createdAt: string, updatedAt: string, message?: string | null, confirmed: boolean, accessToken?: string | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, caretakers?: Array<{ __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null> | null, requestContext?: { __typename?: 'RequestContext', contextHeader?: { __typename?: 'ContextHeader', topTitle?: string | null, mainTitle?: string | null, description?: string | null, attentionLevel?: AttentionLevelType | null } | null, eventDetails?: { __typename?: 'EventDetails', title: string, eventID?: string | null, location?: string | null, description?: string | null, startDate: string, endDate?: string | null } | null } | null, timeRange: { __typename?: 'TimeRange', startDate: string, endDate: string }, responses?: Array<{ __typename?: 'CaretakerResponse', responseID: string, requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } | null> | null }> | null }> | null, relatedEvents?: Array<{ __typename?: 'Event', eventID: string, title: string, startDate: string, endDate?: string | null, owner: { __typename?: 'EventOwner', userID: string, viewerRelationship: ViewerRelationshipType, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } }> | null, otherEvents?: Array<{ __typename?: 'Event', eventID: string, title: string, startDate: string, endDate?: string | null, owner: { __typename?: 'EventOwner', userID: string, viewerRelationship: ViewerRelationshipType, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } }> | null, playdateInvites?: Array<{ __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null }> | null } }> }> } };

export type GenerateSuggestionsQueryVariables = Exact<{
  input: GenerateSuggestionInput;
}>;


export type GenerateSuggestionsQuery = { __typename?: 'Query', generateSuggestions: { __typename?: 'SuggestionResult', suggestionType: RequestedFeature, playdateInviteSuggestions?: Array<{ __typename?: 'PlaydateInviteSuggestion', id: string, scheduleSuggestion?: { __typename?: 'ScheduleSuggestion', reason?: string | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> } | null, textualSuggestion?: { __typename?: 'TextualSuggestion', title?: string | null, details?: string | null, location?: string | null, reason?: string | null } | null }> | null } };

export type GetAnalysisStatusQueryVariables = Exact<{
  taskID: Scalars['String']['input'];
}>;


export type GetAnalysisStatusQuery = { __typename?: 'Query', getAnalysisStatus?: { __typename?: 'AnalysisStatus', taskID: string, status: TaskStatusType, createdAt: string, completedAt: string } | null };

export type GetCalendarConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalendarConnectionsQuery = { __typename?: 'Query', getCalendarConnections: Array<{ __typename?: 'CalendarConnection', source: ExternalSource, identifier: string, expired: boolean, label: string, calendars?: Array<{ __typename?: 'CalendarEntry', id: string, name: string, type: string }> | null }> };

export type GetCaretakerRequestQueryVariables = Exact<{
  requestID?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  responseType?: InputMaybe<CaretakerResponseType>;
}>;


export type GetCaretakerRequestQuery = { __typename?: 'Query', getCaretakerRequest?: { __typename?: 'CaretakerRequest', requestID: string, createdAt: string, updatedAt: string, message?: string | null, confirmed: boolean, accessToken?: string | null, filteredResponses?: Array<{ __typename?: 'CaretakerResponse', responseID: string, requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } | null> | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, caretakers?: Array<{ __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null> | null, requestContext?: { __typename?: 'RequestContext', contextHeader?: { __typename?: 'ContextHeader', topTitle?: string | null, mainTitle?: string | null, description?: string | null, attentionLevel?: AttentionLevelType | null } | null, eventDetails?: { __typename?: 'EventDetails', title: string, eventID?: string | null, location?: string | null, description?: string | null, startDate: string, endDate?: string | null } | null } | null, timeRange: { __typename?: 'TimeRange', startDate: string, endDate: string }, responses?: Array<{ __typename?: 'CaretakerResponse', responseID: string, requestID: string, createdAt: string, updatedAt: string, responseType?: CaretakerResponseType | null, requester: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, responder?: { __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null } | null } | null> | null } | null };

export type GetCaretakerDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaretakerDetailsQuery = { __typename?: 'Query', getCaretakerDetails: Array<{ __typename?: 'CaretakerDetails', userID: string, name: string, contactInfo: string, isInactive: boolean, userSummary?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null }> };

export type GetDeviceRequiredSyncQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
  taskEnvironment: TaskEnvironmentType;
}>;


export type GetDeviceRequiredSyncQuery = { __typename?: 'Query', getDeviceRequiredSync?: Array<{ __typename?: 'CalendarSyncStatus', calendarID: string, status: TaskStatusType, lastCompletedAt: string, source: SyncSourceType, syncRange?: { __typename?: 'SyncRange', start: string, end: string } | null } | null> | null };

export type NotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotificationQuery = { __typename?: 'Query', notification?: { __typename?: 'Notification', id: string, type: NotificationType, icon: NotificationIconType, seenState: SeenState, createdAt: any, content: { __typename?: 'NotificationContent', rawText: string, formattedText?: string | null }, mainCTA?: { __typename?: 'NotificationCTA', label?: string | null, actionType: NotificationActionType, url?: string | null } | null, metadata?: { __typename: 'ChildcareNotificationMetadata', requestID: string, responseID?: string | null } | { __typename: 'GenericReminderMetadata', reminderID?: string | null, eventDate?: any | null, message?: string | null } | { __typename: 'PlaydateNotificationMetadata', inviteID: string, responseID?: string | null } | null } | null };

export type GetPlaydateInviteQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
}>;


export type GetPlaydateInviteQuery = { __typename?: 'Query', getPlaydateInvite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null };

export type GetSyncStatusQueryVariables = Exact<{
  syncType: SyncType;
}>;


export type GetSyncStatusQuery = { __typename?: 'Query', getSyncStatus?: { __typename?: 'SyncStatus', type: SyncType, status: TaskStatusType, createdAt: string, completedAt: string, syncRange?: { __typename?: 'SyncRange', start: string, end: string } | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, spouseEmail?: string | null, spouse?: { __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } | null, family?: { __typename?: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | null } | null };

export type GetCalendarsListQueryVariables = Exact<{
  calendar: CalendarConnectionInput;
}>;


export type GetCalendarsListQuery = { __typename?: 'Query', getUserExternalCalendarList: Array<{ __typename?: 'CalendarMetadata', id: string, identifier: string, source: ExternalSource, name: string } | null> };

export type GetUserOnboardingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOnboardingStatusQuery = { __typename?: 'Query', getUserOnboardingStatus: { __typename?: 'OnboardingStatus', completed: boolean, featureIntroStatus?: { __typename?: 'FeatureIntroStatus', digest?: boolean | null, inviteCreate?: boolean | null } | null } };

export type ListConnectionHubPagesQueryVariables = Exact<{
  filters?: InputMaybe<ConnectionHubPageFilterInput>;
}>;


export type ListConnectionHubPagesQuery = { __typename?: 'Query', fetchConnectionHubPages: Array<{ __typename?: 'ConnectionHubPage', renderType: ConnectionRenderType, sections: Array<{ __typename?: 'ConnectionSection', id: string, title: string, priorityType?: PriorityType | null, networkType?: NetworkType | null, urgencyType?: UrgencyType | null, message?: string | null, count: number, connections: Array<{ __typename?: 'Connection', connectionID: string, status: ConnectionStatus, createdAt: string, updatedAt: string, participant: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } }> }>, connectionsMeta: Array<{ __typename?: 'ConnectionsMeta', filter: ConnectionFilterType, renderType: ConnectionRenderType, initialCursor?: string | null }> }> };

export type ListConnectionSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListConnectionSectionsQuery = { __typename?: 'Query', fetchConnectionSections: Array<{ __typename?: 'ConnectionSection', id: string, title: string, priorityType?: PriorityType | null, networkType?: NetworkType | null, count: number, connections: Array<{ __typename?: 'Connection', connectionID: string, status: ConnectionStatus, createdAt: string, updatedAt: string, participant: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } }> }> };

export type ListConnectionsQueryVariables = Exact<{
  renderType: ConnectionRenderType;
}>;


export type ListConnectionsQuery = { __typename?: 'Query', getConnections: { __typename?: 'ConnectionConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectionEdge', cursor: string, node: { __typename?: 'Connection', connectionID: string, status: ConnectionStatus, createdAt: string, updatedAt: string, participant: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type ListConnectionsByFilterQueryVariables = Exact<{
  filter: ConnectionFilterInput;
  renderType: ConnectionRenderType;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListConnectionsByFilterQuery = { __typename?: 'Query', fetchConnectionsByFilter: { __typename?: 'ConnectionConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectionEdge', cursor: string, node: { __typename?: 'Connection', connectionID: string, status: ConnectionStatus, createdAt: string, updatedAt: string, participant: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type ListInboxInvitesQueryVariables = Exact<{
  guestID: Scalars['String']['input'];
  seenState?: InputMaybe<SeenStatus>;
  since?: InputMaybe<Scalars['Time']['input']>;
  hasOrganizerID?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListInboxInvitesQuery = { __typename?: 'Query', listInboxInvites: { __typename?: 'PlaydateInviteConnection', edges: Array<{ __typename?: 'PlaydateInviteEdge', cursor: string, node: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type NotificationsQueryVariables = Exact<{
  seenState?: InputMaybe<SeenState>;
  since?: InputMaybe<Scalars['Time']['input']>;
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', id: string, type: NotificationType, icon: NotificationIconType, seenState: SeenState, createdAt: any, content: { __typename?: 'NotificationContent', rawText: string, formattedText?: string | null }, mainCTA?: { __typename?: 'NotificationCTA', label?: string | null, actionType: NotificationActionType, url?: string | null } | null, metadata?: { __typename: 'ChildcareNotificationMetadata', requestID: string, responseID?: string | null } | { __typename: 'GenericReminderMetadata', reminderID?: string | null, eventDate?: any | null, message?: string | null } | { __typename: 'PlaydateNotificationMetadata', inviteID: string, responseID?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type ListPlaydateInvitesQueryVariables = Exact<{
  organizerID: Scalars['ID']['input'];
  seenState?: InputMaybe<SeenStatus>;
  since?: InputMaybe<Scalars['Time']['input']>;
  hasGuestID?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListPlaydateInvitesQuery = { __typename?: 'Query', listPlaydateInvites: { __typename?: 'PlaydateInviteConnection', edges: Array<{ __typename?: 'PlaydateInviteEdge', cursor: string, node: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, responses?: Array<{ __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, invite?: { __typename?: 'PlaydateInvite', inviteID: string, createdAt: any, updatedAt: any, title: string, location?: string | null, playdateType: PlaydateType, scheduleOptionType: ScheduleOptionType, guestType: PlaydateGuestType, rsvpDeadline?: any | null, details?: string | null, expired?: boolean | null, status: InviteStatus, recurrenceStartDate?: any | null, scheduleOptions: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }>, organizer: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, guests?: Array<{ __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }> | null, viewerResponse?: { __typename?: 'PlaydateInviteResponse', responseID: string, inviteID: string, responseType: ResponseType, message?: string | null, createdAt: any, updatedAt: any, guest: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string }, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null } | null, externalGuests?: Array<{ __typename?: 'ExternalGuest', name: string, contactInfo: string }> | null, finalScheduleOption?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null, selectedScheduleOptions?: Array<{ __typename?: 'ScheduleOption', date?: any | null, dayOfWeek?: DayOfWeek | null, dayPart?: DayPart | null, startTime?: any | null, endTime?: any | null }> | null }> | null, guestUpdate?: { __typename?: 'PlaydateInviteGuestUpdate', guestID: string, updateID: string, updateType: GuestUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any } | null, organizerUpdate?: { __typename?: 'PlaydateInviteOrganizerUpdate', organizerID: string, updateID: string, updateType: OrganizerUpdateType, message?: string | null, seenState: SeenStatus, createdAt: any, updatedAt: any, lastResponder?: { __typename?: 'Responder', responder?: { __typename: 'FamilySummary', id: string, name: string, children?: Array<{ __typename?: 'ChildSummary', name: string, gender?: string | null }> | null, parents: Array<{ __typename?: 'UserSummary', id: string, email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null }> } | { __typename: 'UserSummary', id: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, email: string } | null, externalGuest?: { __typename?: 'ExternalGuest', name: string, contactInfo: string } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CheckSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckSessionQuery = { __typename?: 'Query', checkSession: { __typename?: 'SessionStatus', authenticated: boolean, user?: { __typename?: 'User', email: string, firstName?: string | null, lastName?: string | null, profilePictureUrl?: string | null, onboardingStatus?: { __typename?: 'OnboardingStatus', completed: boolean } | null } | null } };

export const UserSummaryFragmentFragmentDoc = gql`
    fragment UserSummaryFragment on UserSummary {
  id
  firstName
  lastName
  profilePictureUrl
  email
}
    `;
export const CaretakerDetailsFragmentFragmentDoc = gql`
    fragment CaretakerDetailsFragment on CaretakerDetails {
  userID
  name
  contactInfo
  isInactive
  userSummary {
    ...UserSummaryFragment
  }
}
    ${UserSummaryFragmentFragmentDoc}`;
export const RequestContextFragmentFragmentDoc = gql`
    fragment RequestContextFragment on RequestContext {
  contextHeader {
    topTitle
    mainTitle
    description
    attentionLevel
  }
  eventDetails {
    title
    eventID
    location
    description
    startDate
    endDate
  }
}
    `;
export const CaretakerResponseFragmentFragmentDoc = gql`
    fragment CaretakerResponseFragment on CaretakerResponse {
  responseID
  requestID
  createdAt
  updatedAt
  requester {
    ...UserSummaryFragment
  }
  responder {
    ...CaretakerDetailsFragment
  }
  responseType
}
    ${UserSummaryFragmentFragmentDoc}
${CaretakerDetailsFragmentFragmentDoc}`;
export const CaretakerRequestFragmentFragmentDoc = gql`
    fragment CaretakerRequestFragment on CaretakerRequest {
  requestID
  createdAt
  updatedAt
  requester {
    ...UserSummaryFragment
  }
  caretakers {
    ...CaretakerDetailsFragment
  }
  requestContext {
    ...RequestContextFragment
  }
  timeRange {
    startDate
    endDate
  }
  message
  confirmed
  accessToken
  responses {
    ...CaretakerResponseFragment
  }
}
    ${UserSummaryFragmentFragmentDoc}
${CaretakerDetailsFragmentFragmentDoc}
${RequestContextFragmentFragmentDoc}
${CaretakerResponseFragmentFragmentDoc}`;
export const ConnectionFragmentFragmentDoc = gql`
    fragment ConnectionFragment on Connection {
  connectionID
  status
  createdAt
  updatedAt
  participant {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
}
    `;
export const EventOwnerFragmentFragmentDoc = gql`
    fragment EventOwnerFragment on EventOwner {
  userID
  viewerRelationship
  userSummary {
    ...UserSummaryFragment
  }
}
    ${UserSummaryFragmentFragmentDoc}`;
export const NotificationFragmentFragmentDoc = gql`
    fragment NotificationFragment on Notification {
  id
  type
  icon
  content {
    rawText
    formattedText
  }
  mainCTA {
    label
    actionType
    url
  }
  seenState
  createdAt
  metadata {
    __typename
    ... on PlaydateNotificationMetadata {
      __typename
      inviteID
      responseID
    }
    ... on ChildcareNotificationMetadata {
      __typename
      requestID
      responseID
    }
    ... on GenericReminderMetadata {
      __typename
      reminderID
      eventDate
      message
    }
  }
}
    `;
export const FamilySummaryFragmentFragmentDoc = gql`
    fragment FamilySummaryFragment on FamilySummary {
  id
  name
  children {
    name
    gender
  }
  parents {
    id
    email
    firstName
    lastName
    profilePictureUrl
  }
}
    `;
export const ParticipantSummaryFragmentFragmentDoc = gql`
    fragment ParticipantSummaryFragment on ParticipantSummary {
  __typename
  ... on UserSummary {
    ...UserSummaryFragment
  }
  ... on FamilySummary {
    ...FamilySummaryFragment
  }
}
    ${UserSummaryFragmentFragmentDoc}
${FamilySummaryFragmentFragmentDoc}`;
export const ScheduleOptionFragmentFragmentDoc = gql`
    fragment ScheduleOptionFragment on ScheduleOption {
  date
  dayOfWeek
  dayPart
  startTime
  endTime
}
    `;
export const ScheduleSuggestionFragmentFragmentDoc = gql`
    fragment ScheduleSuggestionFragment on ScheduleSuggestion {
  scheduleOptions {
    ...ScheduleOptionFragment
  }
  reason
}
    ${ScheduleOptionFragmentFragmentDoc}`;
export const TextualSuggestionFragmentFragmentDoc = gql`
    fragment TextualSuggestionFragment on TextualSuggestion {
  title
  details
  location
  reason
}
    `;
export const PlaydateInviteSuggestionFragmentFragmentDoc = gql`
    fragment PlaydateInviteSuggestionFragment on PlaydateInviteSuggestion {
  id
  scheduleSuggestion {
    ...ScheduleSuggestionFragment
  }
  textualSuggestion {
    ...TextualSuggestionFragment
  }
}
    ${ScheduleSuggestionFragmentFragmentDoc}
${TextualSuggestionFragmentFragmentDoc}`;
export const ExternalGuestFragmentFragmentDoc = gql`
    fragment ExternalGuestFragment on ExternalGuest {
  name
  contactInfo
}
    `;
export const PlaydateInviteResponseShallowFragmentFragmentDoc = gql`
    fragment PlaydateInviteResponseShallowFragment on PlaydateInviteResponse {
  responseID
  inviteID
  guest {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
  externalGuest {
    ...ExternalGuestFragment
  }
  responseType
  selectedScheduleOptions {
    ...ScheduleOptionFragment
  }
  message
  createdAt
  updatedAt
}
    ${ExternalGuestFragmentFragmentDoc}
${ScheduleOptionFragmentFragmentDoc}`;
export const PlaydateInviteGuestUpdateFragmentFragmentDoc = gql`
    fragment PlaydateInviteGuestUpdateFragment on PlaydateInviteGuestUpdate {
  guestID
  updateID
  updateType
  message
  seenState
  createdAt
  updatedAt
}
    `;
export const PlaydateInviteOrganizerUpdateFragmentFragmentDoc = gql`
    fragment PlaydateInviteOrganizerUpdateFragment on PlaydateInviteOrganizerUpdate {
  organizerID
  updateID
  updateType
  message
  lastResponder {
    responder {
      __typename
      ... on UserSummary {
        id
        firstName
        lastName
        profilePictureUrl
        email
      }
      ... on FamilySummary {
        id
        name
        children {
          name
          gender
        }
        parents {
          id
          email
          firstName
          lastName
          profilePictureUrl
        }
      }
    }
    externalGuest {
      ...ExternalGuestFragment
    }
  }
  seenState
  createdAt
  updatedAt
}
    ${ExternalGuestFragmentFragmentDoc}`;
export const PlaydateInviteShallowFragmentFragmentDoc = gql`
    fragment PlaydateInviteShallowFragment on PlaydateInvite {
  inviteID
  createdAt
  updatedAt
  title
  location
  playdateType
  scheduleOptionType
  scheduleOptions {
    ...ScheduleOptionFragment
  }
  guestType
  rsvpDeadline
  details
  expired
  organizer {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
  guests {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
  viewerResponse {
    ...PlaydateInviteResponseShallowFragment
  }
  externalGuests {
    ...ExternalGuestFragment
  }
  status
  recurrenceStartDate
  finalScheduleOption {
    ...ScheduleOptionFragment
  }
  guestUpdate {
    ...PlaydateInviteGuestUpdateFragment
  }
  organizerUpdate {
    ...PlaydateInviteOrganizerUpdateFragment
  }
}
    ${ScheduleOptionFragmentFragmentDoc}
${PlaydateInviteResponseShallowFragmentFragmentDoc}
${ExternalGuestFragmentFragmentDoc}
${PlaydateInviteGuestUpdateFragmentFragmentDoc}
${PlaydateInviteOrganizerUpdateFragmentFragmentDoc}`;
export const PlaydateInviteResponseFragmentFragmentDoc = gql`
    fragment PlaydateInviteResponseFragment on PlaydateInviteResponse {
  responseID
  inviteID
  guest {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
  invite {
    ...PlaydateInviteShallowFragment
  }
  externalGuest {
    ...ExternalGuestFragment
  }
  responseType
  selectedScheduleOptions {
    ...ScheduleOptionFragment
  }
  message
  createdAt
  updatedAt
}
    ${PlaydateInviteShallowFragmentFragmentDoc}
${ExternalGuestFragmentFragmentDoc}
${ScheduleOptionFragmentFragmentDoc}`;
export const PlaydateInviteFragmentFragmentDoc = gql`
    fragment PlaydateInviteFragment on PlaydateInvite {
  inviteID
  createdAt
  updatedAt
  title
  location
  playdateType
  scheduleOptionType
  scheduleOptions {
    ...ScheduleOptionFragment
  }
  guestType
  rsvpDeadline
  details
  expired
  organizer {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
  guests {
    __typename
    ... on UserSummary {
      id
      firstName
      lastName
      profilePictureUrl
      email
    }
    ... on FamilySummary {
      id
      name
      children {
        name
        gender
      }
      parents {
        id
        email
        firstName
        lastName
        profilePictureUrl
      }
    }
  }
  externalGuests {
    ...ExternalGuestFragment
  }
  status
  recurrenceStartDate
  finalScheduleOption {
    ...ScheduleOptionFragment
  }
  viewerResponse {
    ...PlaydateInviteResponseFragment
  }
  responses {
    ...PlaydateInviteResponseFragment
  }
  guestUpdate {
    ...PlaydateInviteGuestUpdateFragment
  }
  organizerUpdate {
    ...PlaydateInviteOrganizerUpdateFragment
  }
}
    ${ScheduleOptionFragmentFragmentDoc}
${ExternalGuestFragmentFragmentDoc}
${PlaydateInviteResponseFragmentFragmentDoc}
${PlaydateInviteGuestUpdateFragmentFragmentDoc}
${PlaydateInviteOrganizerUpdateFragmentFragmentDoc}`;
export const OnboardingStatusFieldsFragmentDoc = gql`
    fragment OnboardingStatusFields on OnboardingStatus {
  completed
  featureIntroStatus {
    digest
    inviteCreate
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  email
  firstName
  lastName
  profilePictureUrl
  spouseEmail
  spouse {
    id
    email
    firstName
    lastName
    profilePictureUrl
  }
  onboardingStatus {
    ...OnboardingStatusFields
  }
  family {
    ...FamilySummaryFragment
  }
}
    ${OnboardingStatusFieldsFragmentDoc}
${FamilySummaryFragmentFragmentDoc}`;
export const UserWithMatchedFamilyFieldsFragmentDoc = gql`
    fragment UserWithMatchedFamilyFields on User {
  id
  email
  firstName
  lastName
  profilePictureUrl
  spouseEmail
  spouse {
    id
    email
    firstName
    lastName
    profilePictureUrl
  }
  onboardingStatus {
    ...OnboardingStatusFields
  }
  family {
    ...FamilySummaryFragment
  }
  matchedFamily {
    ...FamilySummaryFragment
  }
}
    ${OnboardingStatusFieldsFragmentDoc}
${FamilySummaryFragmentFragmentDoc}`;
export const AddCaretakerDocument = gql`
    mutation AddCaretaker($input: CaretakerInput!) {
  addCaretaker(input: $input) {
    userID
    name
    contactInfo
    isInactive
  }
}
    `;
export type AddCaretakerMutationFn = Apollo.MutationFunction<AddCaretakerMutation, AddCaretakerMutationVariables>;

/**
 * __useAddCaretakerMutation__
 *
 * To run a mutation, you first call `useAddCaretakerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaretakerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaretakerMutation, { data, loading, error }] = useAddCaretakerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCaretakerMutation(baseOptions?: Apollo.MutationHookOptions<AddCaretakerMutation, AddCaretakerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaretakerMutation, AddCaretakerMutationVariables>(AddCaretakerDocument, options);
      }
export type AddCaretakerMutationHookResult = ReturnType<typeof useAddCaretakerMutation>;
export type AddCaretakerMutationResult = Apollo.MutationResult<AddCaretakerMutation>;
export type AddCaretakerMutationOptions = Apollo.BaseMutationOptions<AddCaretakerMutation, AddCaretakerMutationVariables>;
export const AddExternalCalendarsDocument = gql`
    mutation AddExternalCalendars($calendar: CalendarConnectionInput!, $entries: [CalendarEntryInput!]!) {
  addExternalCalendars(input: $calendar, entries: $entries) {
    success
  }
}
    `;
export type AddExternalCalendarsMutationFn = Apollo.MutationFunction<AddExternalCalendarsMutation, AddExternalCalendarsMutationVariables>;

/**
 * __useAddExternalCalendarsMutation__
 *
 * To run a mutation, you first call `useAddExternalCalendarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalCalendarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExternalCalendarsMutation, { data, loading, error }] = useAddExternalCalendarsMutation({
 *   variables: {
 *      calendar: // value for 'calendar'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useAddExternalCalendarsMutation(baseOptions?: Apollo.MutationHookOptions<AddExternalCalendarsMutation, AddExternalCalendarsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExternalCalendarsMutation, AddExternalCalendarsMutationVariables>(AddExternalCalendarsDocument, options);
      }
export type AddExternalCalendarsMutationHookResult = ReturnType<typeof useAddExternalCalendarsMutation>;
export type AddExternalCalendarsMutationResult = Apollo.MutationResult<AddExternalCalendarsMutation>;
export type AddExternalCalendarsMutationOptions = Apollo.BaseMutationOptions<AddExternalCalendarsMutation, AddExternalCalendarsMutationVariables>;
export const AddUserToFamilyDocument = gql`
    mutation AddUserToFamily($familyID: ID!) {
  addUserToFamily(familyID: $familyID) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type AddUserToFamilyMutationFn = Apollo.MutationFunction<AddUserToFamilyMutation, AddUserToFamilyMutationVariables>;

/**
 * __useAddUserToFamilyMutation__
 *
 * To run a mutation, you first call `useAddUserToFamilyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToFamilyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToFamilyMutation, { data, loading, error }] = useAddUserToFamilyMutation({
 *   variables: {
 *      familyID: // value for 'familyID'
 *   },
 * });
 */
export function useAddUserToFamilyMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToFamilyMutation, AddUserToFamilyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToFamilyMutation, AddUserToFamilyMutationVariables>(AddUserToFamilyDocument, options);
      }
export type AddUserToFamilyMutationHookResult = ReturnType<typeof useAddUserToFamilyMutation>;
export type AddUserToFamilyMutationResult = Apollo.MutationResult<AddUserToFamilyMutation>;
export type AddUserToFamilyMutationOptions = Apollo.BaseMutationOptions<AddUserToFamilyMutation, AddUserToFamilyMutationVariables>;
export const CreateCaretakerRequestDocument = gql`
    mutation CreateCaretakerRequest($input: CreateCaretakerRequestInput!) {
  createCaretakerRequest(input: $input) {
    ...CaretakerRequestFragment
  }
}
    ${CaretakerRequestFragmentFragmentDoc}`;
export type CreateCaretakerRequestMutationFn = Apollo.MutationFunction<CreateCaretakerRequestMutation, CreateCaretakerRequestMutationVariables>;

/**
 * __useCreateCaretakerRequestMutation__
 *
 * To run a mutation, you first call `useCreateCaretakerRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaretakerRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaretakerRequestMutation, { data, loading, error }] = useCreateCaretakerRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaretakerRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaretakerRequestMutation, CreateCaretakerRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaretakerRequestMutation, CreateCaretakerRequestMutationVariables>(CreateCaretakerRequestDocument, options);
      }
export type CreateCaretakerRequestMutationHookResult = ReturnType<typeof useCreateCaretakerRequestMutation>;
export type CreateCaretakerRequestMutationResult = Apollo.MutationResult<CreateCaretakerRequestMutation>;
export type CreateCaretakerRequestMutationOptions = Apollo.BaseMutationOptions<CreateCaretakerRequestMutation, CreateCaretakerRequestMutationVariables>;
export const CreateCaretakerResponseDocument = gql`
    mutation CreateCaretakerResponse($input: CreateCaretakeResponseInput!) {
  createCaretakerResponse(input: $input) {
    requestID
    requester {
      ...UserSummaryFragment
    }
    createdAt
    updatedAt
    responder {
      ...CaretakerDetailsFragment
    }
    responseType
  }
}
    ${UserSummaryFragmentFragmentDoc}
${CaretakerDetailsFragmentFragmentDoc}`;
export type CreateCaretakerResponseMutationFn = Apollo.MutationFunction<CreateCaretakerResponseMutation, CreateCaretakerResponseMutationVariables>;

/**
 * __useCreateCaretakerResponseMutation__
 *
 * To run a mutation, you first call `useCreateCaretakerResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaretakerResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaretakerResponseMutation, { data, loading, error }] = useCreateCaretakerResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaretakerResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaretakerResponseMutation, CreateCaretakerResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaretakerResponseMutation, CreateCaretakerResponseMutationVariables>(CreateCaretakerResponseDocument, options);
      }
export type CreateCaretakerResponseMutationHookResult = ReturnType<typeof useCreateCaretakerResponseMutation>;
export type CreateCaretakerResponseMutationResult = Apollo.MutationResult<CreateCaretakerResponseMutation>;
export type CreateCaretakerResponseMutationOptions = Apollo.BaseMutationOptions<CreateCaretakerResponseMutation, CreateCaretakerResponseMutationVariables>;
export const CreateInteractionDocument = gql`
    mutation CreateInteraction($messages: [NewMessageInput]) {
  createInteraction(messages: $messages) {
    id
    title
    messages {
      role
      content
      createTimestamp
      actionPayload {
        taskID
        actionType
        choices {
          label
          choice
          multiSelectOptions {
            label
            choice
          }
        }
      }
    }
  }
}
    `;
export type CreateInteractionMutationFn = Apollo.MutationFunction<CreateInteractionMutation, CreateInteractionMutationVariables>;

/**
 * __useCreateInteractionMutation__
 *
 * To run a mutation, you first call `useCreateInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInteractionMutation, { data, loading, error }] = useCreateInteractionMutation({
 *   variables: {
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useCreateInteractionMutation(baseOptions?: Apollo.MutationHookOptions<CreateInteractionMutation, CreateInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInteractionMutation, CreateInteractionMutationVariables>(CreateInteractionDocument, options);
      }
export type CreateInteractionMutationHookResult = ReturnType<typeof useCreateInteractionMutation>;
export type CreateInteractionMutationResult = Apollo.MutationResult<CreateInteractionMutation>;
export type CreateInteractionMutationOptions = Apollo.BaseMutationOptions<CreateInteractionMutation, CreateInteractionMutationVariables>;
export const CreateOrUpdatePushTokenDocument = gql`
    mutation CreateOrUpdatePushToken($deviceID: String!, $token: String!) {
  createOrUpdatePushToken(deviceId: $deviceID, token: $token) {
    success
  }
}
    `;
export type CreateOrUpdatePushTokenMutationFn = Apollo.MutationFunction<CreateOrUpdatePushTokenMutation, CreateOrUpdatePushTokenMutationVariables>;

/**
 * __useCreateOrUpdatePushTokenMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePushTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePushTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePushTokenMutation, { data, loading, error }] = useCreateOrUpdatePushTokenMutation({
 *   variables: {
 *      deviceID: // value for 'deviceID'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateOrUpdatePushTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePushTokenMutation, CreateOrUpdatePushTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePushTokenMutation, CreateOrUpdatePushTokenMutationVariables>(CreateOrUpdatePushTokenDocument, options);
      }
export type CreateOrUpdatePushTokenMutationHookResult = ReturnType<typeof useCreateOrUpdatePushTokenMutation>;
export type CreateOrUpdatePushTokenMutationResult = Apollo.MutationResult<CreateOrUpdatePushTokenMutation>;
export type CreateOrUpdatePushTokenMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePushTokenMutation, CreateOrUpdatePushTokenMutationVariables>;
export const CreatePlaydateInviteDocument = gql`
    mutation CreatePlaydateInvite($input: CreatePlaydateInviteInput!) {
  createPlaydateInvite(input: $input) {
    ...PlaydateInviteFragment
  }
}
    ${PlaydateInviteFragmentFragmentDoc}`;
export type CreatePlaydateInviteMutationFn = Apollo.MutationFunction<CreatePlaydateInviteMutation, CreatePlaydateInviteMutationVariables>;

/**
 * __useCreatePlaydateInviteMutation__
 *
 * To run a mutation, you first call `useCreatePlaydateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaydateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaydateInviteMutation, { data, loading, error }] = useCreatePlaydateInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaydateInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaydateInviteMutation, CreatePlaydateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaydateInviteMutation, CreatePlaydateInviteMutationVariables>(CreatePlaydateInviteDocument, options);
      }
export type CreatePlaydateInviteMutationHookResult = ReturnType<typeof useCreatePlaydateInviteMutation>;
export type CreatePlaydateInviteMutationResult = Apollo.MutationResult<CreatePlaydateInviteMutation>;
export type CreatePlaydateInviteMutationOptions = Apollo.BaseMutationOptions<CreatePlaydateInviteMutation, CreatePlaydateInviteMutationVariables>;
export const CreatePlaydateInviteResponseDocument = gql`
    mutation CreatePlaydateInviteResponse($input: CreatePlaydateInviteResponseInput!) {
  createPlaydateInviteResponse(input: $input) {
    ...PlaydateInviteResponseFragment
  }
}
    ${PlaydateInviteResponseFragmentFragmentDoc}`;
export type CreatePlaydateInviteResponseMutationFn = Apollo.MutationFunction<CreatePlaydateInviteResponseMutation, CreatePlaydateInviteResponseMutationVariables>;

/**
 * __useCreatePlaydateInviteResponseMutation__
 *
 * To run a mutation, you first call `useCreatePlaydateInviteResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaydateInviteResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaydateInviteResponseMutation, { data, loading, error }] = useCreatePlaydateInviteResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaydateInviteResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaydateInviteResponseMutation, CreatePlaydateInviteResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaydateInviteResponseMutation, CreatePlaydateInviteResponseMutationVariables>(CreatePlaydateInviteResponseDocument, options);
      }
export type CreatePlaydateInviteResponseMutationHookResult = ReturnType<typeof useCreatePlaydateInviteResponseMutation>;
export type CreatePlaydateInviteResponseMutationResult = Apollo.MutationResult<CreatePlaydateInviteResponseMutation>;
export type CreatePlaydateInviteResponseMutationOptions = Apollo.BaseMutationOptions<CreatePlaydateInviteResponseMutation, CreatePlaydateInviteResponseMutationVariables>;
export const DeletePlaydateInviteDocument = gql`
    mutation DeletePlaydateInvite($inviteID: ID!, $cancellationMessage: String) {
  deletePlaydateInvite(
    inviteID: $inviteID
    cancellationMessage: $cancellationMessage
  ) {
    ...PlaydateInviteFragment
  }
}
    ${PlaydateInviteFragmentFragmentDoc}`;
export type DeletePlaydateInviteMutationFn = Apollo.MutationFunction<DeletePlaydateInviteMutation, DeletePlaydateInviteMutationVariables>;

/**
 * __useDeletePlaydateInviteMutation__
 *
 * To run a mutation, you first call `useDeletePlaydateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaydateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaydateInviteMutation, { data, loading, error }] = useDeletePlaydateInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      cancellationMessage: // value for 'cancellationMessage'
 *   },
 * });
 */
export function useDeletePlaydateInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaydateInviteMutation, DeletePlaydateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaydateInviteMutation, DeletePlaydateInviteMutationVariables>(DeletePlaydateInviteDocument, options);
      }
export type DeletePlaydateInviteMutationHookResult = ReturnType<typeof useDeletePlaydateInviteMutation>;
export type DeletePlaydateInviteMutationResult = Apollo.MutationResult<DeletePlaydateInviteMutation>;
export type DeletePlaydateInviteMutationOptions = Apollo.BaseMutationOptions<DeletePlaydateInviteMutation, DeletePlaydateInviteMutationVariables>;
export const HandleNewUserMessageDocument = gql`
    mutation HandleNewUserMessage($interactionID: ID!, $message: NewMessageInput!) {
  handleNewUserMessage(interactionID: $interactionID, message: $message) {
    message {
      role
      content
      createTimestamp
      actionPayload {
        taskID
        actionType
        choices {
          label
          choice
          multiSelectOptions {
            label
            choice
          }
        }
      }
      messageType
    }
    completed
    archive
  }
}
    `;
export type HandleNewUserMessageMutationFn = Apollo.MutationFunction<HandleNewUserMessageMutation, HandleNewUserMessageMutationVariables>;

/**
 * __useHandleNewUserMessageMutation__
 *
 * To run a mutation, you first call `useHandleNewUserMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleNewUserMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleNewUserMessageMutation, { data, loading, error }] = useHandleNewUserMessageMutation({
 *   variables: {
 *      interactionID: // value for 'interactionID'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useHandleNewUserMessageMutation(baseOptions?: Apollo.MutationHookOptions<HandleNewUserMessageMutation, HandleNewUserMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleNewUserMessageMutation, HandleNewUserMessageMutationVariables>(HandleNewUserMessageDocument, options);
      }
export type HandleNewUserMessageMutationHookResult = ReturnType<typeof useHandleNewUserMessageMutation>;
export type HandleNewUserMessageMutationResult = Apollo.MutationResult<HandleNewUserMessageMutation>;
export type HandleNewUserMessageMutationOptions = Apollo.BaseMutationOptions<HandleNewUserMessageMutation, HandleNewUserMessageMutationVariables>;
export const HandleUserActionDocument = gql`
    mutation HandleUserAction($interactionID: ID!, $actionInput: ActionInput!) {
  handleUserAction(interactionID: $interactionID, actionInput: $actionInput) {
    message {
      role
      content
      createTimestamp
      actionPayload {
        taskID
        actionType
        choices {
          label
          choice
          multiSelectOptions {
            label
            choice
          }
        }
      }
    }
    completed
    archive
  }
}
    `;
export type HandleUserActionMutationFn = Apollo.MutationFunction<HandleUserActionMutation, HandleUserActionMutationVariables>;

/**
 * __useHandleUserActionMutation__
 *
 * To run a mutation, you first call `useHandleUserActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleUserActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleUserActionMutation, { data, loading, error }] = useHandleUserActionMutation({
 *   variables: {
 *      interactionID: // value for 'interactionID'
 *      actionInput: // value for 'actionInput'
 *   },
 * });
 */
export function useHandleUserActionMutation(baseOptions?: Apollo.MutationHookOptions<HandleUserActionMutation, HandleUserActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleUserActionMutation, HandleUserActionMutationVariables>(HandleUserActionDocument, options);
      }
export type HandleUserActionMutationHookResult = ReturnType<typeof useHandleUserActionMutation>;
export type HandleUserActionMutationResult = Apollo.MutationResult<HandleUserActionMutation>;
export type HandleUserActionMutationOptions = Apollo.BaseMutationOptions<HandleUserActionMutation, HandleUserActionMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MarkFeatureIntroCompleteDocument = gql`
    mutation MarkFeatureIntroComplete($input: FeatureIntroType!) {
  markFeatureIntroComplete(input: $input) {
    onboardingStatus {
      ...OnboardingStatusFields
    }
  }
}
    ${OnboardingStatusFieldsFragmentDoc}`;
export type MarkFeatureIntroCompleteMutationFn = Apollo.MutationFunction<MarkFeatureIntroCompleteMutation, MarkFeatureIntroCompleteMutationVariables>;

/**
 * __useMarkFeatureIntroCompleteMutation__
 *
 * To run a mutation, you first call `useMarkFeatureIntroCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFeatureIntroCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFeatureIntroCompleteMutation, { data, loading, error }] = useMarkFeatureIntroCompleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkFeatureIntroCompleteMutation(baseOptions?: Apollo.MutationHookOptions<MarkFeatureIntroCompleteMutation, MarkFeatureIntroCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFeatureIntroCompleteMutation, MarkFeatureIntroCompleteMutationVariables>(MarkFeatureIntroCompleteDocument, options);
      }
export type MarkFeatureIntroCompleteMutationHookResult = ReturnType<typeof useMarkFeatureIntroCompleteMutation>;
export type MarkFeatureIntroCompleteMutationResult = Apollo.MutationResult<MarkFeatureIntroCompleteMutation>;
export type MarkFeatureIntroCompleteMutationOptions = Apollo.BaseMutationOptions<MarkFeatureIntroCompleteMutation, MarkFeatureIntroCompleteMutationVariables>;
export const MarkNotificationsSeenDocument = gql`
    mutation MarkNotificationsSeen($notificationIDs: [ID!]!) {
  markNotificationsSeen(notificationIDs: $notificationIDs)
}
    `;
export type MarkNotificationsSeenMutationFn = Apollo.MutationFunction<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>;

/**
 * __useMarkNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsSeenMutation, { data, loading, error }] = useMarkNotificationsSeenMutation({
 *   variables: {
 *      notificationIDs: // value for 'notificationIDs'
 *   },
 * });
 */
export function useMarkNotificationsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>(MarkNotificationsSeenDocument, options);
      }
export type MarkNotificationsSeenMutationHookResult = ReturnType<typeof useMarkNotificationsSeenMutation>;
export type MarkNotificationsSeenMutationResult = Apollo.MutationResult<MarkNotificationsSeenMutation>;
export type MarkNotificationsSeenMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>;
export const MarkOnboardingCompleteDocument = gql`
    mutation MarkOnboardingComplete {
  markOnboardingComplete {
    completed
  }
}
    `;
export type MarkOnboardingCompleteMutationFn = Apollo.MutationFunction<MarkOnboardingCompleteMutation, MarkOnboardingCompleteMutationVariables>;

/**
 * __useMarkOnboardingCompleteMutation__
 *
 * To run a mutation, you first call `useMarkOnboardingCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOnboardingCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOnboardingCompleteMutation, { data, loading, error }] = useMarkOnboardingCompleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkOnboardingCompleteMutation(baseOptions?: Apollo.MutationHookOptions<MarkOnboardingCompleteMutation, MarkOnboardingCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOnboardingCompleteMutation, MarkOnboardingCompleteMutationVariables>(MarkOnboardingCompleteDocument, options);
      }
export type MarkOnboardingCompleteMutationHookResult = ReturnType<typeof useMarkOnboardingCompleteMutation>;
export type MarkOnboardingCompleteMutationResult = Apollo.MutationResult<MarkOnboardingCompleteMutation>;
export type MarkOnboardingCompleteMutationOptions = Apollo.BaseMutationOptions<MarkOnboardingCompleteMutation, MarkOnboardingCompleteMutationVariables>;
export const RemoveCalendarConnectionDocument = gql`
    mutation RemoveCalendarConnection($calendar: CalendarConnectionInput!) {
  removeCalendarConnection(connection: $calendar) {
    success
  }
}
    `;
export type RemoveCalendarConnectionMutationFn = Apollo.MutationFunction<RemoveCalendarConnectionMutation, RemoveCalendarConnectionMutationVariables>;

/**
 * __useRemoveCalendarConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveCalendarConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCalendarConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCalendarConnectionMutation, { data, loading, error }] = useRemoveCalendarConnectionMutation({
 *   variables: {
 *      calendar: // value for 'calendar'
 *   },
 * });
 */
export function useRemoveCalendarConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCalendarConnectionMutation, RemoveCalendarConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCalendarConnectionMutation, RemoveCalendarConnectionMutationVariables>(RemoveCalendarConnectionDocument, options);
      }
export type RemoveCalendarConnectionMutationHookResult = ReturnType<typeof useRemoveCalendarConnectionMutation>;
export type RemoveCalendarConnectionMutationResult = Apollo.MutationResult<RemoveCalendarConnectionMutation>;
export type RemoveCalendarConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveCalendarConnectionMutation, RemoveCalendarConnectionMutationVariables>;
export const SaveUserProfileDocument = gql`
    mutation SaveUserProfile($input: UserProfileInput!) {
  saveUserProfile(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type SaveUserProfileMutationFn = Apollo.MutationFunction<SaveUserProfileMutation, SaveUserProfileMutationVariables>;

/**
 * __useSaveUserProfileMutation__
 *
 * To run a mutation, you first call `useSaveUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserProfileMutation, { data, loading, error }] = useSaveUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserProfileMutation, SaveUserProfileMutationVariables>(SaveUserProfileDocument, options);
      }
export type SaveUserProfileMutationHookResult = ReturnType<typeof useSaveUserProfileMutation>;
export type SaveUserProfileMutationResult = Apollo.MutationResult<SaveUserProfileMutation>;
export type SaveUserProfileMutationOptions = Apollo.BaseMutationOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>;
export const SaveUserProfilePictureDocument = gql`
    mutation SaveUserProfilePicture($profilePictureURLInput: String!) {
  saveUserProfilePicture(input: $profilePictureURLInput) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type SaveUserProfilePictureMutationFn = Apollo.MutationFunction<SaveUserProfilePictureMutation, SaveUserProfilePictureMutationVariables>;

/**
 * __useSaveUserProfilePictureMutation__
 *
 * To run a mutation, you first call `useSaveUserProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserProfilePictureMutation, { data, loading, error }] = useSaveUserProfilePictureMutation({
 *   variables: {
 *      profilePictureURLInput: // value for 'profilePictureURLInput'
 *   },
 * });
 */
export function useSaveUserProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserProfilePictureMutation, SaveUserProfilePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserProfilePictureMutation, SaveUserProfilePictureMutationVariables>(SaveUserProfilePictureDocument, options);
      }
export type SaveUserProfilePictureMutationHookResult = ReturnType<typeof useSaveUserProfilePictureMutation>;
export type SaveUserProfilePictureMutationResult = Apollo.MutationResult<SaveUserProfilePictureMutation>;
export type SaveUserProfilePictureMutationOptions = Apollo.BaseMutationOptions<SaveUserProfilePictureMutation, SaveUserProfilePictureMutationVariables>;
export const SaveUserSpouseEmailDocument = gql`
    mutation SaveUserSpouseEmail($spouseEmailInput: String!) {
  saveUserSpouseEmail(input: $spouseEmailInput) {
    ...UserWithMatchedFamilyFields
  }
}
    ${UserWithMatchedFamilyFieldsFragmentDoc}`;
export type SaveUserSpouseEmailMutationFn = Apollo.MutationFunction<SaveUserSpouseEmailMutation, SaveUserSpouseEmailMutationVariables>;

/**
 * __useSaveUserSpouseEmailMutation__
 *
 * To run a mutation, you first call `useSaveUserSpouseEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserSpouseEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserSpouseEmailMutation, { data, loading, error }] = useSaveUserSpouseEmailMutation({
 *   variables: {
 *      spouseEmailInput: // value for 'spouseEmailInput'
 *   },
 * });
 */
export function useSaveUserSpouseEmailMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserSpouseEmailMutation, SaveUserSpouseEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserSpouseEmailMutation, SaveUserSpouseEmailMutationVariables>(SaveUserSpouseEmailDocument, options);
      }
export type SaveUserSpouseEmailMutationHookResult = ReturnType<typeof useSaveUserSpouseEmailMutation>;
export type SaveUserSpouseEmailMutationResult = Apollo.MutationResult<SaveUserSpouseEmailMutation>;
export type SaveUserSpouseEmailMutationOptions = Apollo.BaseMutationOptions<SaveUserSpouseEmailMutation, SaveUserSpouseEmailMutationVariables>;
export const UpdateCaretakerResponseDocument = gql`
    mutation UpdateCaretakerResponse($input: UpdateCaretakerResponseInput!) {
  updateCaretakerResponse(input: $input) {
    requestID
    requester {
      ...UserSummaryFragment
    }
    createdAt
    updatedAt
    responder {
      ...CaretakerDetailsFragment
    }
    responseType
  }
}
    ${UserSummaryFragmentFragmentDoc}
${CaretakerDetailsFragmentFragmentDoc}`;
export type UpdateCaretakerResponseMutationFn = Apollo.MutationFunction<UpdateCaretakerResponseMutation, UpdateCaretakerResponseMutationVariables>;

/**
 * __useUpdateCaretakerResponseMutation__
 *
 * To run a mutation, you first call `useUpdateCaretakerResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaretakerResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaretakerResponseMutation, { data, loading, error }] = useUpdateCaretakerResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaretakerResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaretakerResponseMutation, UpdateCaretakerResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaretakerResponseMutation, UpdateCaretakerResponseMutationVariables>(UpdateCaretakerResponseDocument, options);
      }
export type UpdateCaretakerResponseMutationHookResult = ReturnType<typeof useUpdateCaretakerResponseMutation>;
export type UpdateCaretakerResponseMutationResult = Apollo.MutationResult<UpdateCaretakerResponseMutation>;
export type UpdateCaretakerResponseMutationOptions = Apollo.BaseMutationOptions<UpdateCaretakerResponseMutation, UpdateCaretakerResponseMutationVariables>;
export const UpdateInboxSeenStatusDocument = gql`
    mutation UpdateInboxSeenStatus($itemType: InboxItemType!, $input: ID!) {
  updateInboxSeenStatus(itemType: $itemType, updateID: $input) {
    success
  }
}
    `;
export type UpdateInboxSeenStatusMutationFn = Apollo.MutationFunction<UpdateInboxSeenStatusMutation, UpdateInboxSeenStatusMutationVariables>;

/**
 * __useUpdateInboxSeenStatusMutation__
 *
 * To run a mutation, you first call `useUpdateInboxSeenStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInboxSeenStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInboxSeenStatusMutation, { data, loading, error }] = useUpdateInboxSeenStatusMutation({
 *   variables: {
 *      itemType: // value for 'itemType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInboxSeenStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInboxSeenStatusMutation, UpdateInboxSeenStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInboxSeenStatusMutation, UpdateInboxSeenStatusMutationVariables>(UpdateInboxSeenStatusDocument, options);
      }
export type UpdateInboxSeenStatusMutationHookResult = ReturnType<typeof useUpdateInboxSeenStatusMutation>;
export type UpdateInboxSeenStatusMutationResult = Apollo.MutationResult<UpdateInboxSeenStatusMutation>;
export type UpdateInboxSeenStatusMutationOptions = Apollo.BaseMutationOptions<UpdateInboxSeenStatusMutation, UpdateInboxSeenStatusMutationVariables>;
export const UpdatePlaydateInviteDocument = gql`
    mutation UpdatePlaydateInvite($inviteID: ID!, $input: UpdatePlaydateInviteInput!) {
  updatePlaydateInvite(inviteID: $inviteID, input: $input) {
    ...PlaydateInviteFragment
  }
}
    ${PlaydateInviteFragmentFragmentDoc}`;
export type UpdatePlaydateInviteMutationFn = Apollo.MutationFunction<UpdatePlaydateInviteMutation, UpdatePlaydateInviteMutationVariables>;

/**
 * __useUpdatePlaydateInviteMutation__
 *
 * To run a mutation, you first call `useUpdatePlaydateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaydateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaydateInviteMutation, { data, loading, error }] = useUpdatePlaydateInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaydateInviteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaydateInviteMutation, UpdatePlaydateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaydateInviteMutation, UpdatePlaydateInviteMutationVariables>(UpdatePlaydateInviteDocument, options);
      }
export type UpdatePlaydateInviteMutationHookResult = ReturnType<typeof useUpdatePlaydateInviteMutation>;
export type UpdatePlaydateInviteMutationResult = Apollo.MutationResult<UpdatePlaydateInviteMutation>;
export type UpdatePlaydateInviteMutationOptions = Apollo.BaseMutationOptions<UpdatePlaydateInviteMutation, UpdatePlaydateInviteMutationVariables>;
export const UpdatePlaydateInviteResponseDocument = gql`
    mutation UpdatePlaydateInviteResponse($responseID: ID!, $input: UpdatePlaydateInviteResponseInput!) {
  updatePlaydateInviteResponse(responseID: $responseID, input: $input) {
    ...PlaydateInviteResponseFragment
  }
}
    ${PlaydateInviteResponseFragmentFragmentDoc}`;
export type UpdatePlaydateInviteResponseMutationFn = Apollo.MutationFunction<UpdatePlaydateInviteResponseMutation, UpdatePlaydateInviteResponseMutationVariables>;

/**
 * __useUpdatePlaydateInviteResponseMutation__
 *
 * To run a mutation, you first call `useUpdatePlaydateInviteResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaydateInviteResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaydateInviteResponseMutation, { data, loading, error }] = useUpdatePlaydateInviteResponseMutation({
 *   variables: {
 *      responseID: // value for 'responseID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaydateInviteResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaydateInviteResponseMutation, UpdatePlaydateInviteResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaydateInviteResponseMutation, UpdatePlaydateInviteResponseMutationVariables>(UpdatePlaydateInviteResponseDocument, options);
      }
export type UpdatePlaydateInviteResponseMutationHookResult = ReturnType<typeof useUpdatePlaydateInviteResponseMutation>;
export type UpdatePlaydateInviteResponseMutationResult = Apollo.MutationResult<UpdatePlaydateInviteResponseMutation>;
export type UpdatePlaydateInviteResponseMutationOptions = Apollo.BaseMutationOptions<UpdatePlaydateInviteResponseMutation, UpdatePlaydateInviteResponseMutationVariables>;
export const UpsertChildrenDocument = gql`
    mutation UpsertChildren($children: [ChildInput!]!) {
  upsertChildren(children: $children) {
    children {
      childID
      name
      gender
      birthday
      currentSchool {
        schoolName
        className
      }
    }
  }
}
    `;
export type UpsertChildrenMutationFn = Apollo.MutationFunction<UpsertChildrenMutation, UpsertChildrenMutationVariables>;

/**
 * __useUpsertChildrenMutation__
 *
 * To run a mutation, you first call `useUpsertChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertChildrenMutation, { data, loading, error }] = useUpsertChildrenMutation({
 *   variables: {
 *      children: // value for 'children'
 *   },
 * });
 */
export function useUpsertChildrenMutation(baseOptions?: Apollo.MutationHookOptions<UpsertChildrenMutation, UpsertChildrenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertChildrenMutation, UpsertChildrenMutationVariables>(UpsertChildrenDocument, options);
      }
export type UpsertChildrenMutationHookResult = ReturnType<typeof useUpsertChildrenMutation>;
export type UpsertChildrenMutationResult = Apollo.MutationResult<UpsertChildrenMutation>;
export type UpsertChildrenMutationOptions = Apollo.BaseMutationOptions<UpsertChildrenMutation, UpsertChildrenMutationVariables>;
export const GenerateDigestDocument = gql`
    query GenerateDigest {
  generateDigest {
    userID
    generatedAt
    sections {
      sectionTitle
      sectionDescription
      sectionType
      items {
        itemType
        additionalContext
        attentionLevel
        mainReminderType
        itemHeader {
          topTitle
          mainTitle
          description
        }
        content {
          __typename
          ... on ActionableInvite {
            __typename
            invite {
              ...PlaydateInviteFragment
            }
            suggestion {
              ...PlaydateInviteSuggestionFragment
            }
          }
          ... on Event {
            eventID
            owner {
              ...EventOwnerFragment
            }
            title
            startDate
            endDate
            description
          }
          ... on GroupedEvent {
            date
            mainReminderType
            mainEvents {
              eventID
              title
              owner {
                ...EventOwnerFragment
              }
              reminderType
              startDate
              endDate
              caretakerRequests {
                ...CaretakerRequestFragment
              }
            }
            relatedEvents {
              eventID
              title
              owner {
                ...EventOwnerFragment
              }
              startDate
              endDate
            }
            otherEvents {
              eventID
              title
              owner {
                ...EventOwnerFragment
              }
              startDate
              endDate
            }
            playdateInvites {
              ...PlaydateInviteFragment
            }
          }
        }
      }
    }
  }
}
    ${PlaydateInviteFragmentFragmentDoc}
${PlaydateInviteSuggestionFragmentFragmentDoc}
${EventOwnerFragmentFragmentDoc}
${CaretakerRequestFragmentFragmentDoc}`;

/**
 * __useGenerateDigestQuery__
 *
 * To run a query within a React component, call `useGenerateDigestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateDigestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateDigestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateDigestQuery(baseOptions?: Apollo.QueryHookOptions<GenerateDigestQuery, GenerateDigestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateDigestQuery, GenerateDigestQueryVariables>(GenerateDigestDocument, options);
      }
export function useGenerateDigestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateDigestQuery, GenerateDigestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateDigestQuery, GenerateDigestQueryVariables>(GenerateDigestDocument, options);
        }
export function useGenerateDigestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateDigestQuery, GenerateDigestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateDigestQuery, GenerateDigestQueryVariables>(GenerateDigestDocument, options);
        }
export type GenerateDigestQueryHookResult = ReturnType<typeof useGenerateDigestQuery>;
export type GenerateDigestLazyQueryHookResult = ReturnType<typeof useGenerateDigestLazyQuery>;
export type GenerateDigestSuspenseQueryHookResult = ReturnType<typeof useGenerateDigestSuspenseQuery>;
export type GenerateDigestQueryResult = Apollo.QueryResult<GenerateDigestQuery, GenerateDigestQueryVariables>;
export const GenerateSuggestionsDocument = gql`
    query GenerateSuggestions($input: GenerateSuggestionInput!) {
  generateSuggestions(input: $input) {
    suggestionType
    playdateInviteSuggestions {
      ...PlaydateInviteSuggestionFragment
    }
  }
}
    ${PlaydateInviteSuggestionFragmentFragmentDoc}`;

/**
 * __useGenerateSuggestionsQuery__
 *
 * To run a query within a React component, call `useGenerateSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables> & ({ variables: GenerateSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables>(GenerateSuggestionsDocument, options);
      }
export function useGenerateSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables>(GenerateSuggestionsDocument, options);
        }
export function useGenerateSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables>(GenerateSuggestionsDocument, options);
        }
export type GenerateSuggestionsQueryHookResult = ReturnType<typeof useGenerateSuggestionsQuery>;
export type GenerateSuggestionsLazyQueryHookResult = ReturnType<typeof useGenerateSuggestionsLazyQuery>;
export type GenerateSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGenerateSuggestionsSuspenseQuery>;
export type GenerateSuggestionsQueryResult = Apollo.QueryResult<GenerateSuggestionsQuery, GenerateSuggestionsQueryVariables>;
export const GetAnalysisStatusDocument = gql`
    query GetAnalysisStatus($taskID: String!) {
  getAnalysisStatus(taskID: $taskID) {
    taskID
    status
    createdAt
    completedAt
  }
}
    `;

/**
 * __useGetAnalysisStatusQuery__
 *
 * To run a query within a React component, call `useGetAnalysisStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisStatusQuery({
 *   variables: {
 *      taskID: // value for 'taskID'
 *   },
 * });
 */
export function useGetAnalysisStatusQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables> & ({ variables: GetAnalysisStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables>(GetAnalysisStatusDocument, options);
      }
export function useGetAnalysisStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables>(GetAnalysisStatusDocument, options);
        }
export function useGetAnalysisStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables>(GetAnalysisStatusDocument, options);
        }
export type GetAnalysisStatusQueryHookResult = ReturnType<typeof useGetAnalysisStatusQuery>;
export type GetAnalysisStatusLazyQueryHookResult = ReturnType<typeof useGetAnalysisStatusLazyQuery>;
export type GetAnalysisStatusSuspenseQueryHookResult = ReturnType<typeof useGetAnalysisStatusSuspenseQuery>;
export type GetAnalysisStatusQueryResult = Apollo.QueryResult<GetAnalysisStatusQuery, GetAnalysisStatusQueryVariables>;
export const GetCalendarConnectionsDocument = gql`
    query GetCalendarConnections {
  getCalendarConnections {
    source
    identifier
    expired
    label
    calendars {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useGetCalendarConnectionsQuery__
 *
 * To run a query within a React component, call `useGetCalendarConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCalendarConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>(GetCalendarConnectionsDocument, options);
      }
export function useGetCalendarConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>(GetCalendarConnectionsDocument, options);
        }
export function useGetCalendarConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>(GetCalendarConnectionsDocument, options);
        }
export type GetCalendarConnectionsQueryHookResult = ReturnType<typeof useGetCalendarConnectionsQuery>;
export type GetCalendarConnectionsLazyQueryHookResult = ReturnType<typeof useGetCalendarConnectionsLazyQuery>;
export type GetCalendarConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarConnectionsSuspenseQuery>;
export type GetCalendarConnectionsQueryResult = Apollo.QueryResult<GetCalendarConnectionsQuery, GetCalendarConnectionsQueryVariables>;
export const GetCaretakerRequestDocument = gql`
    query GetCaretakerRequest($requestID: ID, $token: String, $responseType: CaretakerResponseType) {
  getCaretakerRequest(requestID: $requestID, token: $token) {
    ...CaretakerRequestFragment
    filteredResponses: responses(responseType: $responseType) {
      ...CaretakerResponseFragment
    }
  }
}
    ${CaretakerRequestFragmentFragmentDoc}
${CaretakerResponseFragmentFragmentDoc}`;

/**
 * __useGetCaretakerRequestQuery__
 *
 * To run a query within a React component, call `useGetCaretakerRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaretakerRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaretakerRequestQuery({
 *   variables: {
 *      requestID: // value for 'requestID'
 *      token: // value for 'token'
 *      responseType: // value for 'responseType'
 *   },
 * });
 */
export function useGetCaretakerRequestQuery(baseOptions?: Apollo.QueryHookOptions<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>(GetCaretakerRequestDocument, options);
      }
export function useGetCaretakerRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>(GetCaretakerRequestDocument, options);
        }
export function useGetCaretakerRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>(GetCaretakerRequestDocument, options);
        }
export type GetCaretakerRequestQueryHookResult = ReturnType<typeof useGetCaretakerRequestQuery>;
export type GetCaretakerRequestLazyQueryHookResult = ReturnType<typeof useGetCaretakerRequestLazyQuery>;
export type GetCaretakerRequestSuspenseQueryHookResult = ReturnType<typeof useGetCaretakerRequestSuspenseQuery>;
export type GetCaretakerRequestQueryResult = Apollo.QueryResult<GetCaretakerRequestQuery, GetCaretakerRequestQueryVariables>;
export const GetCaretakerDetailsDocument = gql`
    query GetCaretakerDetails {
  getCaretakerDetails {
    userID
    name
    userSummary {
      id
      email
      firstName
      lastName
      profilePictureUrl
    }
    contactInfo
    isInactive
  }
}
    `;

/**
 * __useGetCaretakerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCaretakerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaretakerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaretakerDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaretakerDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>(GetCaretakerDetailsDocument, options);
      }
export function useGetCaretakerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>(GetCaretakerDetailsDocument, options);
        }
export function useGetCaretakerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>(GetCaretakerDetailsDocument, options);
        }
export type GetCaretakerDetailsQueryHookResult = ReturnType<typeof useGetCaretakerDetailsQuery>;
export type GetCaretakerDetailsLazyQueryHookResult = ReturnType<typeof useGetCaretakerDetailsLazyQuery>;
export type GetCaretakerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCaretakerDetailsSuspenseQuery>;
export type GetCaretakerDetailsQueryResult = Apollo.QueryResult<GetCaretakerDetailsQuery, GetCaretakerDetailsQueryVariables>;
export const GetDeviceRequiredSyncDocument = gql`
    query GetDeviceRequiredSync($identifier: String!, $taskEnvironment: TaskEnvironmentType!) {
  getDeviceRequiredSync(
    identifier: $identifier
    taskEnvironment: $taskEnvironment
  ) {
    calendarID
    status
    syncRange {
      start
      end
    }
    lastCompletedAt
    source
  }
}
    `;

/**
 * __useGetDeviceRequiredSyncQuery__
 *
 * To run a query within a React component, call `useGetDeviceRequiredSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceRequiredSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceRequiredSyncQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      taskEnvironment: // value for 'taskEnvironment'
 *   },
 * });
 */
export function useGetDeviceRequiredSyncQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables> & ({ variables: GetDeviceRequiredSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables>(GetDeviceRequiredSyncDocument, options);
      }
export function useGetDeviceRequiredSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables>(GetDeviceRequiredSyncDocument, options);
        }
export function useGetDeviceRequiredSyncSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables>(GetDeviceRequiredSyncDocument, options);
        }
export type GetDeviceRequiredSyncQueryHookResult = ReturnType<typeof useGetDeviceRequiredSyncQuery>;
export type GetDeviceRequiredSyncLazyQueryHookResult = ReturnType<typeof useGetDeviceRequiredSyncLazyQuery>;
export type GetDeviceRequiredSyncSuspenseQueryHookResult = ReturnType<typeof useGetDeviceRequiredSyncSuspenseQuery>;
export type GetDeviceRequiredSyncQueryResult = Apollo.QueryResult<GetDeviceRequiredSyncQuery, GetDeviceRequiredSyncQueryVariables>;
export const NotificationDocument = gql`
    query Notification($id: ID!) {
  notification(id: $id) {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationQuery__
 *
 * To run a query within a React component, call `useNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationQuery(baseOptions: Apollo.QueryHookOptions<NotificationQuery, NotificationQueryVariables> & ({ variables: NotificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, options);
      }
export function useNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationQuery, NotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, options);
        }
export function useNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationQuery, NotificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, options);
        }
export type NotificationQueryHookResult = ReturnType<typeof useNotificationQuery>;
export type NotificationLazyQueryHookResult = ReturnType<typeof useNotificationLazyQuery>;
export type NotificationSuspenseQueryHookResult = ReturnType<typeof useNotificationSuspenseQuery>;
export type NotificationQueryResult = Apollo.QueryResult<NotificationQuery, NotificationQueryVariables>;
export const GetPlaydateInviteDocument = gql`
    query GetPlaydateInvite($inviteID: ID!) {
  getPlaydateInvite(inviteID: $inviteID) {
    ...PlaydateInviteFragment
  }
}
    ${PlaydateInviteFragmentFragmentDoc}`;

/**
 * __useGetPlaydateInviteQuery__
 *
 * To run a query within a React component, call `useGetPlaydateInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaydateInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaydateInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useGetPlaydateInviteQuery(baseOptions: Apollo.QueryHookOptions<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables> & ({ variables: GetPlaydateInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables>(GetPlaydateInviteDocument, options);
      }
export function useGetPlaydateInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables>(GetPlaydateInviteDocument, options);
        }
export function useGetPlaydateInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables>(GetPlaydateInviteDocument, options);
        }
export type GetPlaydateInviteQueryHookResult = ReturnType<typeof useGetPlaydateInviteQuery>;
export type GetPlaydateInviteLazyQueryHookResult = ReturnType<typeof useGetPlaydateInviteLazyQuery>;
export type GetPlaydateInviteSuspenseQueryHookResult = ReturnType<typeof useGetPlaydateInviteSuspenseQuery>;
export type GetPlaydateInviteQueryResult = Apollo.QueryResult<GetPlaydateInviteQuery, GetPlaydateInviteQueryVariables>;
export const GetSyncStatusDocument = gql`
    query GetSyncStatus($syncType: SyncType!) {
  getSyncStatus(syncType: $syncType) {
    type
    status
    syncRange {
      start
      end
    }
    createdAt
    completedAt
  }
}
    `;

/**
 * __useGetSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyncStatusQuery({
 *   variables: {
 *      syncType: // value for 'syncType'
 *   },
 * });
 */
export function useGetSyncStatusQuery(baseOptions: Apollo.QueryHookOptions<GetSyncStatusQuery, GetSyncStatusQueryVariables> & ({ variables: GetSyncStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSyncStatusQuery, GetSyncStatusQueryVariables>(GetSyncStatusDocument, options);
      }
export function useGetSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSyncStatusQuery, GetSyncStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSyncStatusQuery, GetSyncStatusQueryVariables>(GetSyncStatusDocument, options);
        }
export function useGetSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSyncStatusQuery, GetSyncStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSyncStatusQuery, GetSyncStatusQueryVariables>(GetSyncStatusDocument, options);
        }
export type GetSyncStatusQueryHookResult = ReturnType<typeof useGetSyncStatusQuery>;
export type GetSyncStatusLazyQueryHookResult = ReturnType<typeof useGetSyncStatusLazyQuery>;
export type GetSyncStatusSuspenseQueryHookResult = ReturnType<typeof useGetSyncStatusSuspenseQuery>;
export type GetSyncStatusQueryResult = Apollo.QueryResult<GetSyncStatusQuery, GetSyncStatusQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  getUser {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetCalendarsListDocument = gql`
    query GetCalendarsList($calendar: CalendarConnectionInput!) {
  getUserExternalCalendarList(input: $calendar) {
    id
    identifier
    source
    name
  }
}
    `;

/**
 * __useGetCalendarsListQuery__
 *
 * To run a query within a React component, call `useGetCalendarsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarsListQuery({
 *   variables: {
 *      calendar: // value for 'calendar'
 *   },
 * });
 */
export function useGetCalendarsListQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarsListQuery, GetCalendarsListQueryVariables> & ({ variables: GetCalendarsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarsListQuery, GetCalendarsListQueryVariables>(GetCalendarsListDocument, options);
      }
export function useGetCalendarsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarsListQuery, GetCalendarsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarsListQuery, GetCalendarsListQueryVariables>(GetCalendarsListDocument, options);
        }
export function useGetCalendarsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarsListQuery, GetCalendarsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarsListQuery, GetCalendarsListQueryVariables>(GetCalendarsListDocument, options);
        }
export type GetCalendarsListQueryHookResult = ReturnType<typeof useGetCalendarsListQuery>;
export type GetCalendarsListLazyQueryHookResult = ReturnType<typeof useGetCalendarsListLazyQuery>;
export type GetCalendarsListSuspenseQueryHookResult = ReturnType<typeof useGetCalendarsListSuspenseQuery>;
export type GetCalendarsListQueryResult = Apollo.QueryResult<GetCalendarsListQuery, GetCalendarsListQueryVariables>;
export const GetUserOnboardingStatusDocument = gql`
    query GetUserOnboardingStatus {
  getUserOnboardingStatus {
    ...OnboardingStatusFields
  }
}
    ${OnboardingStatusFieldsFragmentDoc}`;

/**
 * __useGetUserOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useGetUserOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOnboardingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOnboardingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, options);
      }
export function useGetUserOnboardingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, options);
        }
export function useGetUserOnboardingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, options);
        }
export type GetUserOnboardingStatusQueryHookResult = ReturnType<typeof useGetUserOnboardingStatusQuery>;
export type GetUserOnboardingStatusLazyQueryHookResult = ReturnType<typeof useGetUserOnboardingStatusLazyQuery>;
export type GetUserOnboardingStatusSuspenseQueryHookResult = ReturnType<typeof useGetUserOnboardingStatusSuspenseQuery>;
export type GetUserOnboardingStatusQueryResult = Apollo.QueryResult<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>;
export const ListConnectionHubPagesDocument = gql`
    query ListConnectionHubPages($filters: ConnectionHubPageFilterInput) {
  fetchConnectionHubPages(filters: $filters) {
    renderType
    sections {
      id
      title
      priorityType
      networkType
      urgencyType
      message
      count
      connections {
        ...ConnectionFragment
      }
    }
    connectionsMeta {
      filter
      renderType
      initialCursor
    }
  }
}
    ${ConnectionFragmentFragmentDoc}`;

/**
 * __useListConnectionHubPagesQuery__
 *
 * To run a query within a React component, call `useListConnectionHubPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionHubPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionHubPagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListConnectionHubPagesQuery(baseOptions?: Apollo.QueryHookOptions<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>(ListConnectionHubPagesDocument, options);
      }
export function useListConnectionHubPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>(ListConnectionHubPagesDocument, options);
        }
export function useListConnectionHubPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>(ListConnectionHubPagesDocument, options);
        }
export type ListConnectionHubPagesQueryHookResult = ReturnType<typeof useListConnectionHubPagesQuery>;
export type ListConnectionHubPagesLazyQueryHookResult = ReturnType<typeof useListConnectionHubPagesLazyQuery>;
export type ListConnectionHubPagesSuspenseQueryHookResult = ReturnType<typeof useListConnectionHubPagesSuspenseQuery>;
export type ListConnectionHubPagesQueryResult = Apollo.QueryResult<ListConnectionHubPagesQuery, ListConnectionHubPagesQueryVariables>;
export const ListConnectionSectionsDocument = gql`
    query ListConnectionSections {
  fetchConnectionSections {
    id
    title
    priorityType
    networkType
    count
    connections {
      ...ConnectionFragment
    }
  }
}
    ${ConnectionFragmentFragmentDoc}`;

/**
 * __useListConnectionSectionsQuery__
 *
 * To run a query within a React component, call `useListConnectionSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListConnectionSectionsQuery(baseOptions?: Apollo.QueryHookOptions<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>(ListConnectionSectionsDocument, options);
      }
export function useListConnectionSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>(ListConnectionSectionsDocument, options);
        }
export function useListConnectionSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>(ListConnectionSectionsDocument, options);
        }
export type ListConnectionSectionsQueryHookResult = ReturnType<typeof useListConnectionSectionsQuery>;
export type ListConnectionSectionsLazyQueryHookResult = ReturnType<typeof useListConnectionSectionsLazyQuery>;
export type ListConnectionSectionsSuspenseQueryHookResult = ReturnType<typeof useListConnectionSectionsSuspenseQuery>;
export type ListConnectionSectionsQueryResult = Apollo.QueryResult<ListConnectionSectionsQuery, ListConnectionSectionsQueryVariables>;
export const ListConnectionsDocument = gql`
    query ListConnections($renderType: ConnectionRenderType!) {
  getConnections(renderType: $renderType) {
    edges {
      node {
        ...ConnectionFragment
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${ConnectionFragmentFragmentDoc}`;

/**
 * __useListConnectionsQuery__
 *
 * To run a query within a React component, call `useListConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionsQuery({
 *   variables: {
 *      renderType: // value for 'renderType'
 *   },
 * });
 */
export function useListConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables> & ({ variables: ListConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
      }
export function useListConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
        }
export function useListConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
        }
export type ListConnectionsQueryHookResult = ReturnType<typeof useListConnectionsQuery>;
export type ListConnectionsLazyQueryHookResult = ReturnType<typeof useListConnectionsLazyQuery>;
export type ListConnectionsSuspenseQueryHookResult = ReturnType<typeof useListConnectionsSuspenseQuery>;
export type ListConnectionsQueryResult = Apollo.QueryResult<ListConnectionsQuery, ListConnectionsQueryVariables>;
export const ListConnectionsByFilterDocument = gql`
    query ListConnectionsByFilter($filter: ConnectionFilterInput!, $renderType: ConnectionRenderType!, $first: Int, $after: String) {
  fetchConnectionsByFilter(
    filter: $filter
    renderType: $renderType
    first: $first
    after: $after
  ) {
    edges {
      node {
        ...ConnectionFragment
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${ConnectionFragmentFragmentDoc}`;

/**
 * __useListConnectionsByFilterQuery__
 *
 * To run a query within a React component, call `useListConnectionsByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionsByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionsByFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      renderType: // value for 'renderType'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListConnectionsByFilterQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables> & ({ variables: ListConnectionsByFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables>(ListConnectionsByFilterDocument, options);
      }
export function useListConnectionsByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables>(ListConnectionsByFilterDocument, options);
        }
export function useListConnectionsByFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables>(ListConnectionsByFilterDocument, options);
        }
export type ListConnectionsByFilterQueryHookResult = ReturnType<typeof useListConnectionsByFilterQuery>;
export type ListConnectionsByFilterLazyQueryHookResult = ReturnType<typeof useListConnectionsByFilterLazyQuery>;
export type ListConnectionsByFilterSuspenseQueryHookResult = ReturnType<typeof useListConnectionsByFilterSuspenseQuery>;
export type ListConnectionsByFilterQueryResult = Apollo.QueryResult<ListConnectionsByFilterQuery, ListConnectionsByFilterQueryVariables>;
export const ListInboxInvitesDocument = gql`
    query ListInboxInvites($guestID: String!, $seenState: SeenStatus, $since: Time, $hasOrganizerID: ID, $limit: Int!, $cursor: String) {
  listInboxInvites(
    guestID: $guestID
    seenState: $seenState
    hasOrganizerID: $hasOrganizerID
    since: $since
    limit: $limit
    cursor: $cursor
  ) {
    edges {
      node {
        ...PlaydateInviteFragment
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PlaydateInviteFragmentFragmentDoc}`;

/**
 * __useListInboxInvitesQuery__
 *
 * To run a query within a React component, call `useListInboxInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInboxInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInboxInvitesQuery({
 *   variables: {
 *      guestID: // value for 'guestID'
 *      seenState: // value for 'seenState'
 *      since: // value for 'since'
 *      hasOrganizerID: // value for 'hasOrganizerID'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListInboxInvitesQuery(baseOptions: Apollo.QueryHookOptions<ListInboxInvitesQuery, ListInboxInvitesQueryVariables> & ({ variables: ListInboxInvitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInboxInvitesQuery, ListInboxInvitesQueryVariables>(ListInboxInvitesDocument, options);
      }
export function useListInboxInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInboxInvitesQuery, ListInboxInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInboxInvitesQuery, ListInboxInvitesQueryVariables>(ListInboxInvitesDocument, options);
        }
export function useListInboxInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInboxInvitesQuery, ListInboxInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInboxInvitesQuery, ListInboxInvitesQueryVariables>(ListInboxInvitesDocument, options);
        }
export type ListInboxInvitesQueryHookResult = ReturnType<typeof useListInboxInvitesQuery>;
export type ListInboxInvitesLazyQueryHookResult = ReturnType<typeof useListInboxInvitesLazyQuery>;
export type ListInboxInvitesSuspenseQueryHookResult = ReturnType<typeof useListInboxInvitesSuspenseQuery>;
export type ListInboxInvitesQueryResult = Apollo.QueryResult<ListInboxInvitesQuery, ListInboxInvitesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($seenState: SeenState, $since: Time, $limit: Int!, $cursor: String) {
  notifications(
    seenState: $seenState
    since: $since
    limit: $limit
    cursor: $cursor
  ) {
    edges {
      node {
        ...NotificationFragment
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      seenState: // value for 'seenState'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables> & ({ variables: NotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const ListPlaydateInvitesDocument = gql`
    query ListPlaydateInvites($organizerID: ID!, $seenState: SeenStatus, $since: Time, $hasGuestID: ID, $limit: Int!, $cursor: String) {
  listPlaydateInvites(
    organizerID: $organizerID
    seenState: $seenState
    since: $since
    hasGuestID: $hasGuestID
    limit: $limit
    cursor: $cursor
  ) {
    edges {
      node {
        ...PlaydateInviteFragment
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PlaydateInviteFragmentFragmentDoc}`;

/**
 * __useListPlaydateInvitesQuery__
 *
 * To run a query within a React component, call `useListPlaydateInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPlaydateInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPlaydateInvitesQuery({
 *   variables: {
 *      organizerID: // value for 'organizerID'
 *      seenState: // value for 'seenState'
 *      since: // value for 'since'
 *      hasGuestID: // value for 'hasGuestID'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListPlaydateInvitesQuery(baseOptions: Apollo.QueryHookOptions<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables> & ({ variables: ListPlaydateInvitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables>(ListPlaydateInvitesDocument, options);
      }
export function useListPlaydateInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables>(ListPlaydateInvitesDocument, options);
        }
export function useListPlaydateInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables>(ListPlaydateInvitesDocument, options);
        }
export type ListPlaydateInvitesQueryHookResult = ReturnType<typeof useListPlaydateInvitesQuery>;
export type ListPlaydateInvitesLazyQueryHookResult = ReturnType<typeof useListPlaydateInvitesLazyQuery>;
export type ListPlaydateInvitesSuspenseQueryHookResult = ReturnType<typeof useListPlaydateInvitesSuspenseQuery>;
export type ListPlaydateInvitesQueryResult = Apollo.QueryResult<ListPlaydateInvitesQuery, ListPlaydateInvitesQueryVariables>;
export const CheckSessionDocument = gql`
    query CheckSession {
  checkSession {
    authenticated
    user {
      email
      firstName
      lastName
      profilePictureUrl
      onboardingStatus {
        completed
      }
    }
  }
}
    `;

/**
 * __useCheckSessionQuery__
 *
 * To run a query within a React component, call `useCheckSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckSessionQuery(baseOptions?: Apollo.QueryHookOptions<CheckSessionQuery, CheckSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSessionQuery, CheckSessionQueryVariables>(CheckSessionDocument, options);
      }
export function useCheckSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSessionQuery, CheckSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSessionQuery, CheckSessionQueryVariables>(CheckSessionDocument, options);
        }
export function useCheckSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckSessionQuery, CheckSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSessionQuery, CheckSessionQueryVariables>(CheckSessionDocument, options);
        }
export type CheckSessionQueryHookResult = ReturnType<typeof useCheckSessionQuery>;
export type CheckSessionLazyQueryHookResult = ReturnType<typeof useCheckSessionLazyQuery>;
export type CheckSessionSuspenseQueryHookResult = ReturnType<typeof useCheckSessionSuspenseQuery>;
export type CheckSessionQueryResult = Apollo.QueryResult<CheckSessionQuery, CheckSessionQueryVariables>;